const es = {
  // ──────────────────────────────────────────────
  // COMMON
  // ──────────────────────────────────────────────
  'common.loading': 'Cargando...',
  'common.saving': 'Guardando...',
  'common.save': 'Guardar',
  'common.cancel': 'Cancelar',
  'common.close': 'Cerrar',
  'common.delete': 'Eliminar',
  'common.edit': 'Editar',
  'common.add': 'Agregar',
  'common.search': 'Buscar',
  'common.filter': 'Filtrar',
  'common.status': 'Estado',
  'common.actions': 'Acciones',
  'common.active': 'Activo',
  'common.inactive': 'Inactivo',
  'common.all': 'Todos',
  'common.allStatus': 'Todos los estados',
  'common.allClients': 'Todos los clientes',
  'common.previous': 'Anterior',
  'common.next': 'Siguiente',
  'common.page': 'Página',
  'common.of': 'de',
  'common.showing': 'Mostrando',
  'common.noResults': 'No se encontraron resultados',
  'common.required': 'requerido',
  'common.optional': 'Opcional',
  'common.description': 'Descripción',
  'common.name': 'Nombre',
  'common.email': 'Correo electrónico',
  'common.phone': 'Teléfono',
  'common.created': 'Creado',
  'common.updated': 'Actualizado',
  'common.viewDetails': 'Ver detalles',
  'common.saveChanges': 'Guardar cambios',
  'common.addNew': 'Agregar nuevo',
  'common.exportCsv': 'Exportar CSV',
  'common.refresh': 'Actualizar',
  'common.uploadDocument': 'Subir documento',
  'common.uploading': 'Subiendo...',
  'common.noDocuments': 'No hay documentos subidos',
  'common.deleting': 'Eliminando...',
  'common.confirmDelete': '¿Confirmar eliminación?',
  'common.thisActionCannotBeUndone': 'Esta acción no se puede deshacer.',
  'common.yes': 'Sí',
  'common.no': 'No',
  'common.details': 'Detalles',
  'common.preview': 'Vista previa',
  'common.color': 'Color',
  'common.icon': 'Icono',
  'common.website': 'Sitio web',
  'common.industry': 'Industria',
  'common.location': 'Ubicación',
  'common.contact': 'Contacto',
  'common.client': 'Cliente',
  'common.department': 'Departamento',
  'common.role': 'Rol',
  'common.password': 'Contraseña',
  'common.newPassword': 'Nueva contraseña',
  'common.permissions': 'Permisos',
  'common.priority': 'Prioridad',
  'common.category': 'Categoría',
  'common.type': 'Tipo',
  'common.value': 'Valor',
  'common.total': 'Total',
  'common.date': 'Fecha',
  'common.notes': 'Notas',
  'common.documents': 'Documentos',
  'common.plants': 'Plantas',
  'common.contracts': 'Contratos',
  'common.read': 'Leído',
  'common.unread': 'No leído',
  'common.na': 'N/D',
  'common.emDash': '—',
  'common.unknown': 'Desconocido',
  'common.unassigned': 'Sin asignar',
  'common.system': 'Sistema',
  'common.paginationRange': 'Mostrando {{from}}–{{to}} de {{total}}',
  'common.pageOf': 'Página {{page}} de {{totalPages}}',
  'common.idLabel': 'ID: {{id}}',
  'common.searchLabel': 'Buscar',
  'common.errorTitle': 'Algo salió mal',
  'common.errorMessage': 'Ocurrió un error al cargar los datos. Inténtelo de nuevo.',
  'common.tryAgain': 'Reintentar',
  'common.selectOption': 'Seleccione una opción',
  'common.confirm': 'Confirmar',
  'common.tableEmpty': 'No hay datos',

  // ──────────────────────────────────────────────
  // LANGUAGE SWITCHER
  // ──────────────────────────────────────────────
  'lang.switchToEn': 'Cambiar a inglés',
  'lang.switchToEs': 'Cambiar a español',

  // ──────────────────────────────────────────────
  // NAV (GlobalSidebar)
  // ──────────────────────────────────────────────
  'nav.dashboard': 'Panel',
  'nav.slaDashboard': 'Panel SLA',
  'nav.tickets': 'Tickets',
  'nav.plants': 'Plantas',
  'nav.clients': 'Clientes',
  'nav.contracts': 'Contratos',
  'nav.serviceTypes': 'Tipos de servicio',
  'nav.contacts': 'Contactos',
  'nav.departments': 'Departamentos',
  'nav.categories': 'Categorías',
  'nav.reports': 'Reportes',
  'nav.auditLog': 'Registro de auditoría',
  'nav.users': 'Usuarios',
  'nav.notifications': 'Notificaciones',
  'nav.settings': 'Configuración',
  'nav.newTicket': 'Nuevo ticket',
  'nav.editProfile': 'Editar perfil',
  'nav.signOut': 'Cerrar sesión',
  'nav.signedInAs': 'Sesión iniciada como',
  'nav.profile': 'Perfil',
  'nav.signOutConfirmTitle': 'Cerrar sesión',
  'nav.signOutConfirmMsg': '¿Estás seguro de que deseas cerrar sesión de Cysol?',

  // ──────────────────────────────────────────────
  // TOPBAR
  // ──────────────────────────────────────────────
  'topbar.searchPlaceholder': 'Buscar tickets, clientes, plantas...',
  'topbar.notifications': 'Notificaciones',
  'topbar.viewAllNotifications': 'Ver todas las notificaciones',
  'topbar.searching': 'Buscando...',
  'topbar.noResultsFound': 'No se encontraron resultados',
  'topbar.viewAllResults': 'Ver todos los resultados',

  // ──────────────────────────────────────────────
  // HOME PAGE
  // ──────────────────────────────────────────────
  'home.nav.services': 'Servicios',
  'home.nav.about': 'Nosotros',
  'home.nav.contactUs': 'Acceder',
  'home.nav.adminPortal': 'Portal Admin',
  'home.toggleMenu': 'Abrir o cerrar menú',
  'home.logo.tagline': 'Soluciones de limpieza industrial',
  'home.hero.badge': 'Limpieza industrial profesional',
  'home.hero.title': 'Soluciones completas de limpieza para',
  'home.hero.titleHighlight': 'plantas industriales',
  'home.hero.subtitle': 'Plataforma centralizada de gestión de reclamos y tickets de servicio. Visibilidad en tiempo real, seguimiento de SLA y comunicación fluida entre los equipos de Cysol y clientes en toda Argentina.',
  'home.hero.submitTicket': 'Enviar ticket de servicio',
  'home.hero.accessPortal': 'Acceder al portal',
  'home.hero.activePlants': 'Plantas activas',
  'home.hero.support': 'Soporte',
  'home.hero.responseTime': 'Tiempo de respuesta',
  'home.hero.mockTicket.type': 'Mantenimiento de equipos',
  'home.hero.mockTicket.status': 'En progreso',
  'home.hero.mockTicket.plant': 'Planta: San Luis - Producción A',
  'home.hero.mockTicket.assigned': 'Asignado: Equipo de operaciones',
  'home.hero.mockTicket.eta': 'ETA: 4 horas restantes',
  'home.hero.mockTicket.progress': 'Progreso',
  'home.services.title': 'Gestión integral de servicios',
  'home.services.subtitle': 'Nuestra plataforma optimiza la gestión de reclamos, solicitudes de servicio y comunicación operativa en todas sus instalaciones industriales.',
  'home.services.ticketMgmt.title': 'Gestión de tickets',
  'home.services.ticketMgmt.desc': 'Cree, rastree y resuelva tickets de servicio con actualizaciones de estado en tiempo real y notificaciones automáticas.',
  'home.services.slaTracking.title': 'Seguimiento SLA',
  'home.services.slaTracking.desc': 'Monitoree acuerdos de nivel de servicio con escalamiento automático cuando los tiempos de respuesta excedan los umbrales.',
  'home.services.teamCollab.title': 'Colaboración de equipos',
  'home.services.teamCollab.desc': 'Comunicación fluida entre los departamentos de operaciones, RRHH, comercial y administración.',
  'home.services.dashboard.title': 'Panel en tiempo real',
  'home.services.dashboard.desc': 'Analíticas completas y KPIs para tendencias de reclamos, tiempos de resolución y rendimiento del equipo.',
  'home.services.auditHistory.title': 'Historial de auditoría',
  'home.services.auditHistory.desc': 'Cronología completa de todas las acciones, comentarios y cambios de estado para total transparencia y trazabilidad.',
  'home.services.smartNotif.title': 'Notificaciones inteligentes',
  'home.services.smartNotif.desc': 'Alertas automáticas para asignaciones de tickets, escalamientos y actualizaciones de resolución a todos los involucrados.',
  'home.about.title': 'Sobre Cysol',
  'home.about.p1': 'Cysol es una empresa líder en limpieza industrial en Argentina, especializada en soluciones integrales de limpieza para plantas de manufactura, depósitos e instalaciones industriales.',
  'home.about.p2': 'Nuestra plataforma de gestión de tickets fue creada para eliminar el caos en la comunicación, brindar visibilidad en tiempo real y asegurar que cada reclamo sea rastreado, asignado y resuelto eficientemente con total trazabilidad.',
  'home.about.feature1.title': 'Equipo profesional',
  'home.about.feature1.desc': 'Departamentos experimentados de operaciones, RRHH, comercial y administración trabajando en conjunto.',
  'home.about.feature2.title': 'Soporte 24/7',
  'home.about.feature2.desc': 'Monitoreo y respuesta las 24 horas para necesidades críticas de limpieza industrial.',
  'home.about.feature3.title': 'Garantía de calidad',
  'home.about.feature3.desc': 'Cumplimiento estricto de SLA y protocolos de escalamiento para garantizar resolución oportuna.',
  'home.about.stat.activePlants': 'Plantas activas',
  'home.about.stat.ticketsResolved': 'Tickets resueltos',
  'home.about.stat.clientSatisfaction': 'Satisfacción del cliente',
  'home.about.stat.avgResponse': 'Respuesta promedio',
  'home.cta.title': '¿Listo para optimizar su gestión de servicios?',
  'home.cta.subtitle': 'Únase a nuestra plataforma hoy y experimente seguimiento de reclamos fluido, actualizaciones en tiempo real y flujos de resolución eficientes.',
  'home.cta.submitFirst': 'Envíe su primer ticket',
  'home.cta.accessPortal': 'Acceder al portal',
  'home.footer.description': 'Soluciones profesionales de limpieza industrial con gestión integral de tickets de servicio en toda Argentina.',
  'home.footer.quickLinks': 'Enlaces rápidos',
  'home.footer.services': 'Servicios',
  'home.footer.aboutUs': 'Sobre nosotros',
  'home.footer.login': 'Iniciar sesión',
  'home.footer.contact': 'Contacto',
  'home.footer.rights': 'Todos los derechos reservados.',
  'home.footer.tagline': 'Soluciones profesionales de limpieza industrial.',

  // ──────────────────────────────────────────────
  // LOGIN PAGE
  // ──────────────────────────────────────────────
  'login.welcomeBack': 'Bienvenido de nuevo',
  'login.subtitle': 'Inicie sesión para acceder a su portal de gestión de solicitudes',
  'login.emailAddress': 'Correo electrónico',
  'login.emailPlaceholder': 'usted@empresa.com',
  'login.forgotEmailPlaceholder': 'su@correo.com',
  'login.clientPortalLinkMissing':
    'Su cuenta es del portal de clientes, pero no hay un contacto vinculado a este correo. Pida a su administrador que cree un contacto con el mismo email o inicie sesión desde el portal de clientes.',
  'login.password': 'Contraseña',
  'login.rememberMe': 'Recordarme',
  'login.forgotPassword': '¿Olvidó su contraseña?',
  'login.signIn': 'Iniciar sesión',
  'login.signingIn': 'Iniciando sesión...',
  'login.needAccess': '¿Necesita acceso?',
  'login.contactAdmin': 'Contacte a su administrador',
  'login.feature1': 'Seguimiento de tickets en tiempo real',
  'login.feature1Desc': 'Monitoree todos los reclamos en más de 16 plantas industriales',
  'login.feature2': 'Escalamiento automático',
  'login.feature2Desc': 'Nunca pierda un SLA con notificaciones inteligentes',
  'login.feature3': 'Auditoría completa',
  'login.feature3Desc': 'Historial completo y trazabilidad para cada ticket',
  'login.errorInvalidCredentials': 'Correo electrónico o contraseña inválidos. Por favor, intente de nuevo.',
  'login.passwordPlaceholder': 'Ingrese su contraseña',
  'login.forgotInstructions': 'Ingrese su correo electrónico y le enviaremos instrucciones para restablecer su contraseña.',
  'login.send': 'Enviar',
  'login.forgotSuccess': 'Si existe una cuenta con ese correo electrónico, recibirá instrucciones para restablecer su contraseña.',
  'login.brandBadge': 'Servicios industriales con trazabilidad total',
  'login.brandTitle': 'Limpieza, mantenimiento y jardinería con control digital',
  'login.brandDescription': 'Optimice sus operaciones de limpieza industrial con visibilidad en tiempo real, seguimiento de SLA y colaboración fluida en todas sus plantas.',

  // ──────────────────────────────────────────────
  // RESET PASSWORD
  // ──────────────────────────────────────────────
  'resetPassword.title': 'Restablecer contraseña',
  'resetPassword.send': 'Enviar',
  'resetPassword.subtitle': 'Ingrese su nueva contraseña abajo',
  'resetPassword.newPassword': 'Nueva contraseña',
  'resetPassword.confirmPassword': 'Confirmar contraseña',
  'resetPassword.placeholderNew': 'Ingrese la nueva contraseña',
  'resetPassword.placeholderConfirm': 'Confirme la nueva contraseña',
  'resetPassword.goLogin': 'Ir al inicio de sesión',
  'resetPassword.noToken': 'No se encontró token de restablecimiento. Solicite uno nuevo desde la página de inicio de sesión.',
  'resetPassword.submit': 'Restablecer contraseña',
  'resetPassword.submitting': 'Restableciendo…',
  'resetPassword.err.invalidToken': 'Token inválido o faltante. Solicite un nuevo restablecimiento de contraseña.',
  'resetPassword.err.shortPassword': 'La contraseña debe tener al menos 6 caracteres.',
  'resetPassword.err.mismatch': 'Las contraseñas no coinciden.',
  'resetPassword.err.network': 'Error de red. Inténtelo de nuevo.',
  'resetPassword.successDefault': 'La contraseña se restableció correctamente.',
  'resetPassword.failedDefault': 'No se pudo restablecer la contraseña. El enlace puede haber expirado.',
  'resetPassword.backToLogin': '← Volver al inicio de sesión',

  // ──────────────────────────────────────────────
  // DASHBOARD
  // ──────────────────────────────────────────────
  'dashboard.title': 'Panel',
  'dashboard.subtitle': 'Resumen del sistema de gestión de reclamos',
  'dashboard.exportReport': 'Exportar reporte',
  'dashboard.escalationAlert': 'Alerta de escalamiento: Atención inmediata requerida',
  'dashboard.escalatedTickets': 'ticket(s) escalado(s)',
  'dashboard.overdueSlA': 'ticket(s) con SLA vencido',
  'dashboard.viewAllEscalated': 'Ver todos los tickets escalados',
  'dashboard.thisWeek': 'Esta semana',
  'dashboard.failedToLoad': 'Error al cargar el panel',
  'dashboard.kpi.totalComplaints': 'Total de reclamos',
  'dashboard.kpi.openComplaints': 'Reclamos abiertos',
  'dashboard.kpi.resolvedComplaints': 'Reclamos resueltos',
  'dashboard.kpi.escalatedComplaints': 'Reclamos escalados',
  'dashboard.weeklyProgress': 'Progreso semanal',
  'dashboard.complaintsByCategory': 'Reclamos por categoría',
  'dashboard.complaintsByDept': 'Reclamos por departamento',
  'dashboard.topPlants': 'Principales plantas por reclamos',
  'dashboard.recentActivity': 'Actividad reciente',
  'dashboard.viewAllPlants': 'Ver todas las plantas',
  'dashboard.loadErrorMessage': 'No pudimos cargar los datos del panel. Compruebe su conexión e inténtelo de nuevo.',
  'dashboard.refreshingToast': 'Actualizando datos del panel...',
  'dashboard.exportSuccessToast': '¡Datos del panel exportados correctamente!',
  'dashboard.banner.requireAction': '{{escalatedCount}} {{escalatedLabel}} y {{overdueCount}} {{overdueLabel}} requieren acción inmediata.',
  'dashboard.overdueHours': '{{hours}}h de retraso',
  'dashboard.moreEscalatedTickets': '+ {{count}} ticket(s) escalado(s) más',
  'dashboard.kpiBadge.active': 'Activo',
  'dashboard.kpiBadge.completed': 'Completado',
  'dashboard.kpiBadge.urgent': 'Urgente',
  'dashboard.pendingComplaints': '{{count}} reclamos pendientes de resolución',
  'dashboard.completionRate': 'Tasa de finalización',
  'dashboard.activity.escalated': 'escaló el ticket',
  'dashboard.activity.created': 'creó el ticket',
  'dashboard.activity.resolved': 'resolvió el ticket',
  'dashboard.activity.closed': 'cerró el ticket',
  'dashboard.activity.updated': 'actualizó el ticket',
  'dashboard.export.summary': 'Resumen del panel',
  'dashboard.export.metric': 'Métrica,Valor',
  'dashboard.export.totalComplaints': 'Total de reclamos',
  'dashboard.export.openComplaints': 'Reclamos abiertos',
  'dashboard.export.resolved': 'Resueltos',
  'dashboard.export.escalated': 'Escalados',
  'dashboard.export.completionRate': 'Tasa de finalización',
  'dashboard.export.byCategory': 'Por categoría',
  'dashboard.export.categoryHeader': 'Categoría,Cantidad,Porcentaje',
  'dashboard.export.byDepartment': 'Por departamento',
  'dashboard.export.departmentHeader': 'Departamento,Cantidad,Porcentaje',
  'dashboard.export.recentTickets': 'Tickets recientes',
  'dashboard.export.ticketsHeader': 'ID,Título,Cliente,Planta,Estado,Prioridad,Responsable,Creado',

  // ──────────────────────────────────────────────
  // PLANTS
  // ──────────────────────────────────────────────
  'plants.title': 'Gestión de plantas',
  'plants.subtitle': 'Administre plantas industriales en todas las ubicaciones de clientes',
  'plants.addNew': 'Agregar nueva planta',
  'plants.totalPlants': 'Total de plantas',
  'plants.activePlants': 'Plantas activas',
  'plants.comingSoon': 'Próximamente',
  'plants.totalClients': 'Total de clientes',
  'plants.searchPlaceholder': 'Buscar por nombre, ubicación o cliente...',
  'plants.filterStatus': 'Estado',
  'plants.filterClient': 'Cliente',
  'plants.col.plantName': 'Nombre de planta',
  'plants.col.client': 'Cliente',
  'plants.col.location': 'Ubicación',
  'plants.col.status': 'Estado',
  'plants.col.created': 'Creado',
  'plants.col.actions': 'Acciones',
  'plants.loading': 'Cargando plantas...',
  'plants.notFound': 'No se encontraron plantas con los filtros seleccionados',
  'plants.modal.addTitle': 'Agregar nueva planta',
  'plants.modal.editTitle': 'Editar planta',
  'plants.modal.detailTitle': 'Detalle de planta',
  'plants.form.plantName': 'Nombre de planta',
  'plants.form.client': 'Cliente',
  'plants.form.location': 'Ubicación',
  'plants.form.status': 'Estado',
  'plants.form.contactEmail': 'Correo de contacto',
  'plants.form.contactPhone': 'Teléfono de contacto',
  'plants.form.selectClient': 'Seleccione un cliente',
  'plants.form.adding': 'Agregando...',
  'plants.form.addPlant': 'Agregar planta',
  'plants.form.saving': 'Guardando...',
  'plants.form.namePlaceholder': 'ej., Planta Quilmes',
  'plants.form.locationPlaceholder': 'ej., Buenos Aires',
  'plants.form.emailPlaceholder': 'correo@ejemplo.com',
  'plants.form.phonePlaceholder': '+54 11 1234-5678',
  'plants.deleteTitle': 'Confirmar eliminación',
  'plants.tooltip.deletePlant': 'Eliminar planta',
  'plants.deleteConfirm': '¿Seguro que desea eliminar esta planta? Esta acción no se puede deshacer.',
  'plants.detail.plantInfo': 'Información de la planta',
  'plants.detail.contactInfo': 'Información de contacto',
  'plants.detail.lastUpdated': 'Última actualización: {{date}}',
  'plants.noActivity': 'Sin actividad',

  // ──────────────────────────────────────────────
  // CLIENTS
  // ──────────────────────────────────────────────
  'clients.title': 'Gestión de clientes',
  'clients.subtitle': 'Administre empresas clientes, contactos y acuerdos de servicio',
  'clients.totalClients': 'Total de clientes',
  'clients.activeClients': 'Clientes activos',
  'clients.pendingPayment': 'Pago pendiente',
  'clients.withManager': 'Con gerente',
  'clients.searchPlaceholder': 'Buscar por nombre, industria o ID...',
  'clients.addClient': 'Agregar cliente',
  'clients.col.client': 'Cliente',
  'clients.col.industry': 'Industria',
  'clients.col.contact': 'Contacto',
  'clients.col.payment': 'Pago',
  'clients.col.accountManager': 'Gerente de cuenta',
  'clients.col.status': 'Estado',
  'clients.col.actions': 'Acciones',
  'clients.loading': 'Cargando clientes...',
  'clients.notFound': 'No se encontraron clientes con los filtros seleccionados',
  'clients.modal.detailTitle': 'Detalles del cliente',
  'clients.modal.addTitle': 'Agregar nuevo cliente',
  'clients.modal.editTitle': 'Editar cliente',
  'clients.detail.email': 'Correo',
  'clients.detail.phone': 'Teléfono',
  'clients.detail.website': 'Sitio web',
  'clients.detail.industry': 'Industria',
  'clients.detail.status': 'Estado',
  'clients.detail.paymentStatus': 'Estado de pago',
  'clients.detail.accountManager': 'Gerente de cuenta',
  'clients.detail.created': 'Creado',
  'clients.editClient': 'Editar cliente',
  'clients.form.companyName': 'Nombre de la empresa',
  'clients.form.industry': 'Industria',
  'clients.form.companyPlaceholder': 'Nombre de la empresa',
  'clients.form.industryPlaceholder': 'ej., agroindustria',
  'clients.form.emailPlaceholder': 'correo@empresa.com',
  'clients.form.phonePlaceholder': '+54 9 XXX XXX-XXXX',
  'clients.form.websitePlaceholder': 'https://www.empresa.com',
  'clients.deleteTitle': 'Confirmar eliminación',
  'clients.payment.current': 'Al día',
  'clients.payment.pending': 'Pendiente',
  'clients.payment.overdue': 'Vencido',
  'clients.deleteConfirm': '¿Seguro que desea eliminar "{{name}}"? Esta acción no se puede deshacer.',

  // ──────────────────────────────────────────────
  // USERS
  // ──────────────────────────────────────────────
  'users.title': 'Gestión de usuarios y roles',
  'users.subtitle': 'Administre usuarios, roles, permisos y departamentos',
  'users.totalUsers': 'Total de usuarios',
  'users.activeUsers': 'Usuarios activos',
  'users.roles': 'Roles',
  'users.departments': 'Departamentos',
  'users.tab.users': 'Usuarios',
  'users.tab.roles': 'Roles',
  'users.tab.departments': 'Departamentos',
  'users.searchPlaceholder': 'Buscar por nombre, correo o ID...',
  'users.allRoles': 'Todos los roles',
  'users.addUser': 'Agregar usuario',
  'users.col.user': 'Usuario',
  'users.col.role': 'Rol',
  'users.col.department': 'Departamento',
  'users.col.contact': 'Contacto',
  'users.col.status': 'Estado',
  'users.col.actions': 'Acciones',
  'users.notFound': 'No se encontraron usuarios con los filtros seleccionados',
  'users.modal.addTitle': 'Agregar nuevo usuario',
  'users.modal.editTitle': 'Editar usuario',
  'users.modal.viewTitle': 'Ver usuario',
  'users.form.fullName': 'Nombre completo',
  'users.form.email': 'Correo',
  'users.form.phone': 'Teléfono',
  'users.form.password': 'Contraseña',
  'users.form.newPassword': 'Nueva contraseña',
  'users.form.role': 'Rol',
  'users.form.status': 'Estado',
  'users.form.selectRole': 'Seleccione un rol',
  'users.form.adding': 'Agregando...',
  'users.form.addUser': 'Agregar usuario',
  'users.form.saving': 'Guardando...',
  'users.form.leaveBlank': 'Dejar en blanco para mantener la contraseña actual',
  'users.roles.manageDesc': 'Gestionar roles y permisos',
  'users.roles.addRole': 'Agregar rol',
  'users.roles.addTitle': 'Agregar nuevo rol',
  'users.roles.editTitle': 'Editar rol',
  'users.roles.roleName': 'Nombre del rol',
  'users.roles.description': 'Descripción',
  'users.roles.department': 'Departamento',
  'users.roles.roleNamePlaceholder': 'Ingrese el nombre del rol',
  'users.roles.descPlaceholder': 'Describa las responsabilidades del rol',
  'users.roles.selectDept': 'Seleccione departamento',
  'users.roles.notFound': 'No se encontraron roles',
  'users.roles.adding': 'Agregando...',
  'users.roles.addRoleBtn': 'Agregar rol',
  'users.roles.saving': 'Guardando...',
  'users.depts.overview': 'Vista general y estadísticas de departamentos',
  'users.depts.notFound': 'No se encontraron departamentos',
  'users.loadError': 'Error al cargar usuarios',
  'users.allStatus': 'Todos los estados',
  'users.showingRange': 'Mostrando {{from}}–{{to}} de {{total}}',
  'users.morePermissions': '+{{count}} más',
  'users.emailPlaceholder': 'email@cysol.com.ar',
  'users.phonePlaceholder': '+54 9 XXX XXX-XXXX',
  'users.form.fullNamePlaceholder': 'Nombre completo',
  'users.form.passwordPlaceholder': 'Contraseña',
  'users.roles.deleteTitle': 'Eliminar rol',
  'users.roles.deleteConfirm':
    '¿Seguro que desea eliminar {{name}}? Esta acción no se puede deshacer.',
  'users.roles.deleting': 'Eliminando...',
  'users.roles.delete': 'Eliminar',

  // ──────────────────────────────────────────────
  // DEPARTMENTS
  // ──────────────────────────────────────────────
  'departments.title': 'Departamentos',
  'departments.subtitle': 'Administre departamentos organizacionales y sus asignaciones',
  'departments.totalDepts': 'Total de departamentos',
  'departments.active': 'Activos',
  'departments.inactive': 'Inactivos',
  'departments.thisPage': 'Esta página',
  'departments.searchPlaceholder': 'Buscar departamentos...',
  'departments.addDept': 'Agregar departamento',
  'departments.notFound': 'No se encontraron departamentos',
  'departments.modal.addTitle': 'Agregar departamento',
  'departments.modal.editTitle': 'Editar departamento',
  'departments.form.deptName': 'Nombre del departamento',
  'departments.form.description': 'Descripción',
  'departments.form.status': 'Estado',
  'departments.form.deptNamePlaceholder': 'ej., Control de calidad',
  'departments.form.descPlaceholder': 'Breve descripción del departamento',
  'departments.form.adding': 'Agregando...',
  'departments.form.addDept': 'Agregar departamento',
  'departments.form.saving': 'Guardando...',
  'departments.loadError': 'No se pudieron cargar los departamentos',
  'departments.deleteTitle': 'Eliminar departamento',
  'departments.deleteConfirm':
    '¿Seguro que desea eliminar "{{name}}"? Esta acción no se puede deshacer.',
  'departments.createdOn': 'Creado: {{date}}',
  'departments.form.deleting': 'Eliminando...',

  // ──────────────────────────────────────────────
  // CONTACTS
  // ──────────────────────────────────────────────
  'contacts.title': 'Contactos autorizados',
  'contacts.subtitle': 'Administre contactos de clientes autorizados para enviar tickets',
  'contacts.totalContacts': 'Total de contactos',
  'contacts.activeContacts': 'Contactos activos',
  'contacts.clientsCovered': 'Clientes cubiertos',
  'contacts.plantAuthorizations': 'Autorizaciones de planta',
  'contacts.searchPlaceholder': 'Buscar por nombre, correo o cliente...',
  'contacts.addContact': 'Agregar contacto',
  'contacts.col.contact': 'Contacto',
  'contacts.col.client': 'Cliente',
  'contacts.col.phone': 'Teléfono',
  'contacts.col.plants': 'Plantas',
  'contacts.col.created': 'Creado',
  'contacts.col.status': 'Estado',
  'contacts.col.actions': 'Acciones',
  'contacts.notFound': 'No se encontraron contactos',
  'contacts.modal.addTitle': 'Agregar contacto',
  'contacts.modal.editTitle': 'Editar contacto',
  'contacts.form.fullName': 'Nombre completo',
  'contacts.form.email': 'Correo',
  'contacts.form.phone': 'Teléfono',
  'contacts.form.password': 'Contraseña (acceso al portal)',
  'contacts.form.passwordOptional': 'Contraseña (opcional)',
  'contacts.form.canCreateTickets': 'Puede crear tickets',
  'contacts.form.client': 'Cliente',
  'contacts.form.selectClient': 'Seleccione cliente',
  'contacts.form.authorizedPlants': 'Plantas autorizadas',
  'contacts.form.noPlantsForClient': 'No hay plantas para este cliente',
  'contacts.form.saving': 'Guardando...',
  'contacts.form.addContact': 'Agregar contacto',
  'contacts.form.saveChanges': 'Guardar cambios',
  'contacts.delete.title': 'Eliminar contacto',
  'contacts.delete.confirm': '¿Está seguro de que desea eliminar a',
  'contacts.form.namePlaceholder': 'Juan Pérez',
  'contacts.form.emailPlaceholder': 'juan@empresa.com',
  'contacts.form.phonePlaceholder': '+54 9 XXX XXX-XXXX',
  'contacts.form.passwordPlaceholderAdd': 'Defina una contraseña para habilitar el acceso al portal',
  'contacts.form.passwordPlaceholderEdit':
    'Dejar en blanco para mantener la actual • Escriba una nueva contraseña para cambiarla',
  'contacts.form.passwordHelpAdd': 'El contacto usará esta contraseña para iniciar sesión en el portal de cliente.',
  'contacts.form.passwordHelpEdit': 'Rellene solo si desea definir o cambiar la contraseña del portal.',
  'contacts.form.status': 'Estado',
  'contacts.form.position': 'Puesto',
  'contacts.form.selectPosition': 'Seleccionar puesto',
  'contacts.col.position': 'Puesto',
  'contacts.delete.confirmFull':
    '¿Seguro que desea eliminar a {{name}} ({{client}})? Esta acción no se puede deshacer.',
  'contacts.showingRange': 'Mostrando {{from}}–{{to}} de {{total}} contactos',
  'contacts.includeDeleted': 'Incluir eliminados',
  'contacts.deletedBadge': 'Eliminado',
  'contacts.restore': 'Restaurar',
  'contacts.restoreError': 'No se pudo restaurar el contacto',

  // ──────────────────────────────────────────────
  // CONTRACTS
  // ──────────────────────────────────────────────
  'contracts.title': 'Contratos y servicios',
  'contracts.subtitle': 'Administre contratos de clientes y acuerdos de servicio',
  'contracts.totalContracts': 'Total de contratos',
  'contracts.active': 'Activos',
  'contracts.upForRenewal': 'Por renovar',
  'contracts.pending': 'Pendientes',
  'contracts.activeArr': 'ARR activo',
  'contracts.searchPlaceholder': 'Buscar contratos, clientes, IDs...',
  'contracts.allServiceTypes': 'Todos los tipos de servicio',
  'contracts.newContract': 'Nuevo contrato',
  'contracts.loading': 'Cargando contratos...',
  'contracts.notFound': 'No se encontraron contratos',
  'contracts.col.contract': 'Contrato',
  'contracts.col.client': 'Cliente',
  'contracts.col.type': 'Tipo',
  'contracts.col.value': 'Valor',
  'contracts.col.period': 'Período',
  'contracts.col.status': 'Estado',
  'contracts.col.renewal': 'Renovación',
  'contracts.col.actions': 'Acciones',
  'contracts.showing': 'Mostrando',
  'contracts.ofContracts': 'contratos',
  'contracts.modal.newTitle': 'Nuevo contrato',
  'contracts.modal.editTitle': 'Editar contrato',
  'contracts.detail.client': 'Cliente',
  'contracts.detail.accountManager': 'Gerente de cuenta',
  'contracts.detail.contractValue': 'Valor del contrato',
  'contracts.detail.payment': 'Pago',
  'contracts.detail.startDate': 'Fecha de inicio',
  'contracts.detail.endDate': 'Fecha de fin',
  'contracts.detail.renewalDate': 'Fecha de renovación',
  'contracts.detail.signed': 'Firmado',
  'contracts.detail.plantsCovered': 'Plantas incluidas',
  'contracts.detail.servicesIncluded': 'Servicios incluidos',
  'contracts.detail.monthlyTotal': 'Total mensual:',
  'contracts.detail.notes': 'Notas',
  'contracts.detail.documents': 'Documentos',
  'contracts.detail.editContract': 'Editar contrato',
  'contracts.selectClient': 'Seleccione cliente...',
  'contracts.searchClient': 'Buscar cliente...',
  'contracts.plant': 'planta',
  'contracts.plants': 'plantas',
  'contracts.view': 'Ver',
  'contracts.loadingClients': 'Cargando clientes…',
  'contracts.selectAccountManager': 'Seleccionar responsable de cuenta…',
  'contracts.attachHint': 'Adjunte documentos al contrato. Se subirán tras la creación.',
  'contracts.selectFilesAttach': 'Seleccionar archivos para adjuntar',
  'contracts.form.titlePlaceholder': 'ej. Servicios de limpieza industrial — Planta X',
  'contracts.form.notesPlaceholder': 'Requisitos especiales, notas de SLA…',
  'contracts.tooltip.download': 'Descargar',
  'contracts.tooltip.remove': 'Quitar',
  'contracts.filter.allClients': 'Todos los clientes',
  'contracts.filter.allStatus': 'Todos los estados',
  'contracts.showingCount': 'Mostrando {{count}} de {{total}} contratos',
  'contracts.card.periodStart': 'Inicio',
  'contracts.card.periodEnd': 'Fin',
  'contracts.documentsLoading': 'Cargando…',
  'contracts.retry': 'Reintentar',
  'contracts.form.contractTitle': 'Título del contrato',
  'contracts.form.serviceType': 'Tipo de servicio',
  'contracts.form.selectService': 'Seleccionar…',
  'contracts.form.startDate': 'Fecha de inicio',
  'contracts.form.endDate': 'Fecha de fin',
  'contracts.form.renewalDate': 'Fecha de renovación',
  'contracts.form.valueUsd': 'Valor del contrato (USD)',
  'contracts.form.paymentFrequency': 'Frecuencia de pago',
  'contracts.freq.monthly': 'Mensual',
  'contracts.freq.quarterly': 'Trimestral',
  'contracts.freq.annual': 'Anual',
  'contracts.status.expired': 'Vencido',
  'contracts.status.terminated': 'Rescindido',
  'contracts.err.load': 'Error al cargar contratos',
  'contracts.err.loadDropdowns': 'Error al cargar datos',
  'contracts.err.create': 'Error al crear el contrato',
  'contracts.err.update': 'Error al actualizar el contrato',
  'contracts.err.delete': 'Error al eliminar el contrato',
  'contracts.err.uploadAfterCreate': 'Contrato creado pero falló la subida: {{fileName}}',
  'contracts.plantHash': 'Planta n.º {{id}}',
  'contracts.renewalOverdue': '{{days}} d de retraso',
  'contracts.renewalCountdown': '{{days}} d para renovación',
  'contracts.clientHash': 'Cliente n.º {{id}}',
  'contracts.noClientsSearch': 'Ningún cliente coincide con la búsqueda',
  'contracts.noClientsHint': 'No hay clientes. Cree clientes primero en la sección Clientes.',
  'contracts.form.documentsOptional': 'Documentos (opcional)',
  'contracts.createContract': 'Crear contrato',
  'contracts.delete.title': 'Eliminar contrato',
  'contracts.delete.confirm':
    '¿Seguro que desea eliminar "{{title}}"? Esta acción no se puede deshacer.',

  // ──────────────────────────────────────────────
  // CATEGORIES
  // ──────────────────────────────────────────────
  'categories.title': 'Categorías de tickets',
  'categories.subtitle': 'Administre categorías de tickets y asignaciones a departamentos',
  'categories.totalCategories': 'Total de categorías',
  'categories.active': 'Activas',
  'categories.inactive': 'Inactivas',
  'categories.departments': 'Departamentos',
  'categories.searchPlaceholder': 'Buscar categorías...',
  'categories.addCategory': 'Agregar categoría',
  'categories.col.category': 'Categoría',
  'categories.col.department': 'Departamento',
  'categories.col.created': 'Creado',
  'categories.col.status': 'Estado',
  'categories.col.actions': 'Acciones',
  'categories.notFound': 'No se encontraron categorías',
  'categories.showing': 'Mostrando',
  'categories.ofCategories': 'categorías',
  'categories.modal.addTitle': 'Agregar categoría',
  'categories.modal.editTitle': 'Editar categoría',
  'categories.form.categoryName': 'Nombre de categoría',
  'categories.form.description': 'Descripción',
  'categories.form.department': 'Departamento',
  'categories.form.color': 'Color',
  'categories.form.icon': 'Icono',
  'categories.form.preview': 'Vista previa',
  'categories.form.status': 'Estado',
  'categories.form.selectDept': 'Seleccione departamento',
  'categories.form.saving': 'Guardando...',
  'categories.form.saving2': 'Guardando...',
  'categories.form.addCategory': 'Agregar categoría',
  'categories.form.namePlaceholder': 'ej., Incidente de seguridad',
  'categories.form.descPlaceholder': 'Breve descripción de esta categoría',
  'categories.form.previewFallback': 'Nombre de categoría',
  'categories.showingRange': 'Mostrando {{from}}–{{to}} de {{total}} categorías',
  'categories.err.load': 'No se pudieron cargar las categorías',
  'categories.err.create': 'No se pudo crear la categoría',
  'categories.err.update': 'No se pudo actualizar la categoría',
  'categories.err.delete': 'No se pudo eliminar la categoría',
  'categories.err.toggleStatus': 'Error al cambiar el estado de la categoría',
  'categories.delete.title': 'Eliminar categoría',
  'categories.delete.confirm':
    '¿Seguro que desea eliminar "{{name}}"? Esta acción no se puede deshacer.',
  'categories.form.deleting': 'Eliminando...',
  'categories.icon.document': 'Documento',
  'categories.icon.user': 'Usuario',
  'categories.icon.tools': 'Herramientas',
  'categories.icon.chat': 'Chat',
  'categories.icon.briefcase': 'Maletín',
  'categories.icon.alert': 'Alerta',
  'categories.icon.settings': 'Ajustes',
  'categories.icon.more': 'Más',

  // ──────────────────────────────────────────────
  // AUDIT LOG
  // ──────────────────────────────────────────────
  'audit.title': 'Registro de auditoría',
  'audit.subtitle': 'Trazabilidad completa de todas las acciones y eventos del sistema',
  'audit.exportCsv': 'Exportar CSV',
  'audit.totalEvents': 'Total de eventos',
  'audit.criticalEvents': 'Eventos críticos',
  'audit.warnings': 'Advertencias',
  'audit.systemActions': 'Acciones del sistema',
  'audit.searchPlaceholder': 'Buscar eventos, usuarios, entidades...',
  'audit.allModules': 'Todos los módulos',
  'audit.allSeverities': 'Todas las severidades',
  'audit.allUsers': 'Todos los usuarios',
  'audit.col.timestamp': 'Fecha/hora',
  'audit.col.user': 'Usuario',
  'audit.col.action': 'Acción',
  'audit.col.module': 'Módulo',
  'audit.col.entity': 'Entidad',
  'audit.col.ip': 'IP',
  'audit.col.severity': 'Severidad',
  'audit.loading': 'Cargando eventos...',
  'audit.notFound': 'No se encontraron eventos',
  'audit.showing': 'Mostrando',
  'audit.ofEvents': 'eventos',
  'audit.clickToExpand': 'Haga clic en una fila para expandir detalles',
  'audit.severity.info': 'Info',
  'audit.severity.warning': 'Advertencia',
  'audit.severity.critical': 'Crítico',
  'audit.detailsLabel': 'Detalles:',
  'audit.showingOfTotal': 'Mostrando {{shown}} de {{total}} eventos',
  'audit.loadError': 'No se pudieron cargar los eventos de auditoría',

  // ──────────────────────────────────────────────
  // SLA DASHBOARD
  // ──────────────────────────────────────────────
  'sla.title': 'Panel SLA',
  'sla.loading': 'Cargando datos SLA…',
  'sla.loadError': 'Error al cargar datos SLA',
  'sla.subtitle': 'Monitoreo de cumplimiento SLA en tiempo real y gestión proactiva de brechas',
  'sla.liveIndicator': 'En vivo · Última actualización hace un momento',
  'sla.overallCompliance': 'Cumplimiento general',
  'sla.ticketsAtRisk': 'Tickets en riesgo',
  'sla.overdueTickets': 'Tickets vencidos',
  'sla.totalTracked': 'Total monitoreado',
  'sla.target': 'Objetivo: 85%',
  'sla.approachingLimit': 'Aproximándose al límite SLA',
  'sla.breachExceeded': 'Incumplimiento SLA superado',
  'sla.onTrack': 'En plazo:',
  'sla.overallSlaCompliance': 'Cumplimiento SLA general',
  'sla.resolvedOnTime': 'Resueltos a tiempo',
  'sla.breachedSla': 'Incumplimiento SLA',
  'sla.complianceByCategory': 'Cumplimiento por categoría',
  'sla.complianceByPriority': 'Cumplimiento por prioridad',
  'sla.ticketsRequiringAttention': 'Tickets que requieren atención',
  'sla.onTrackCount': 'en plazo',
  'sla.tab.summary': 'Resumen',
  'sla.tab.byCategory': 'Por categoría',
  'sla.tab.byCategoryDept': 'Por categoría (vista departamento)',
  'sla.tab.byPriority': 'Por prioridad',
  'sla.col.category': 'Categoría',
  'sla.col.totalTickets': 'Total tickets',
  'sla.col.onTime': 'A tiempo',
  'sla.col.overdue': 'Vencidos',
  'sla.col.compliance': 'Cumplimiento',
  'sla.col.atRisk': 'En riesgo',
  'sla.col.priority': 'Prioridad',
  'sla.col.slaTarget': 'Objetivo SLA',
  'sla.col.total': 'Total',
  'sla.col.complianceVsTarget': 'Cumplimiento vs objetivo',
  'sla.hoursOverdue': 'h vencido',
  'sla.hoursRemaining': 'h restantes',
  'sla.lineHoursOverdue': '{{hours}}h de retraso',
  'sla.lineHoursRemaining': '{{hours}}h restantes',
  'sla.overviewOnTime': '{{onTrack}}/{{total}} a tiempo',
  'sla.targetLine85': 'Objetivo 85%',
  'sla.slaHours': 'SLA:',

  // ──────────────────────────────────────────────
  // NOTIFICATIONS
  // ──────────────────────────────────────────────
  'notifications.title': 'Notificaciones',
  'notifications.subtitle': 'Manténgase actualizado con las actividades de tickets y alertas del sistema',
  'notifications.markAllRead': 'Marcar todas como leídas',
  'notifications.total': 'Total',
  'notifications.unread': 'No leídas',
  'notifications.ticketAlerts': 'Alertas de ticket',
  'notifications.slaWarnings': 'Alertas SLA',
  'notifications.allTypes': 'Todos los tipos',
  'notifications.assigned': 'Asignado',
  'notifications.escalated': 'Escalado',
  'notifications.comments': 'Comentarios',
  'notifications.resolved': 'Resuelto',
  'notifications.created': 'Creado',
  'notifications.slaWarning': 'Alerta SLA',
  'notifications.reassigned': 'Reasignado',
  'notifications.system': 'Sistema',
  'notifications.updated': 'Actualizado',
  'notifications.allStatus': 'Todos los estados',
  'notifications.showingOf': 'Mostrando {{count}} de {{total}} notificaciones',
  'notifications.loading': 'Cargando notificaciones...',
  'notifications.loadError': 'No se pudieron cargar las notificaciones',
  'notifications.markAsReadTitle': 'Marcar como leída',
  'notifications.detailsMoreFields': '+{{count}} más',
  'notifications.eventType.ticket_assigned': 'Ticket asignado',
  'notifications.eventType.ticket_escalated': 'Ticket escalado',
  'notifications.eventType.ticket_comment': 'Nuevo comentario',
  'notifications.eventType.ticket_resolved': 'Ticket resuelto',
  'notifications.eventType.ticket_created': 'Ticket creado',
  'notifications.eventType.sla_warning': 'Alerta SLA',
  'notifications.eventType.ticket_reassigned': 'Ticket reasignado',
  'notifications.eventType.ticket_updated': 'Ticket actualizado',
  'notifications.eventType.system': 'Sistema',
  'notifications.eventFallback': 'Notificación',
  'notifications.ticketNumber': 'Ticket #{{id}}',
  'notifications.notFound': 'No se encontraron notificaciones',
  'notifications.allCaughtUp': '¡Todo al día! No hay notificaciones sin leer.',
  'notifications.adjustFilters': 'Intente ajustar sus filtros para ver más notificaciones.',
  'notifications.modal.dateTime': 'Fecha y hora',
  'notifications.modal.status': 'Estado',
  'notifications.modal.priority': 'Prioridad',
  'notifications.modal.relatedTicket': 'Ticket relacionado',
  'notifications.modal.viewTicket': 'Ver ticket',

  // ──────────────────────────────────────────────
  // SETTINGS
  // ──────────────────────────────────────────────
  'settings.title': 'Configuración',
  'settings.tab.general': 'General',
  'settings.general.title': 'Configuración general',
  'settings.general.subtitle': 'Configuración global del sistema',
  'settings.general.timezone': 'Zona horaria',
  'settings.general.timezoneDesc': 'Todas las fechas y horas del sistema se mostrarán en esta zona horaria',
  'settings.general.timezonePlaceholder': 'Buscar zona horaria…',
  'settings.general.currentTime': 'Hora actual en la zona horaria seleccionada',
  'settings.general.save': 'Guardar',
  'settings.general.saving': 'Guardando…',
  'settings.general.saved': 'Configuración guardada correctamente',
  'settings.general.saveFailed': 'No se pudo guardar la configuración',
  'settings.subtitle':
    'Gestione reglas SLA, políticas de escalamiento, preferencias de notificación, permisos por rol (administración) y enumerables del sistema',
  'settings.tab.sla': 'Reglas SLA',
  'settings.tab.escalation': 'Reglas de escalamiento',
  'settings.tab.notifications': 'Preferencias de notificación',
  'settings.tab.rolePerms': 'Permisos por rol',
  'settings.tab.enums': 'Enumerables',
  'settings.rolePerms.title': 'Permisos por rol',
  'settings.rolePerms.subtitle':
    'Elija un rol y marque o desmarque permisos. Los cambios aplican a todos los usuarios con ese rol. Si modifica su propio rol, la sesión se actualizará al guardar.',
  'settings.rolePerms.loading': 'Cargando roles y permisos…',
  'settings.rolePerms.loadFailed': 'No se pudieron cargar los datos',
  'settings.rolePerms.selectRole': 'Rol a editar',
  'settings.rolePerms.chooseRole': 'Seleccione un rol…',
  'settings.rolePerms.selectAll': 'Marcar todos',
  'settings.rolePerms.clearAll': 'Quitar todos',
  'settings.rolePerms.groupSelect': 'Grupo: marcar',
  'settings.rolePerms.groupClear': 'Grupo: quitar',
  'settings.rolePerms.discard': 'Descartar cambios',
  'settings.rolePerms.warning':
    'Un rol sin el permiso «Gestionar usuarios» no podrá abrir de nuevo esta pantalla. No quite ese permiso a su propio rol sin otro camino de administración.',
  'settings.rolePerms.save': 'Guardar permisos',
  'settings.rolePerms.saving': 'Guardando…',
  'settings.rolePerms.saved': 'Permisos del rol actualizados correctamente',
  'settings.rolePerms.saveFailed': 'No se pudieron guardar los permisos',
  'settings.rolePerms.reload': 'Recargar lista',
  'settings.rolePerms.loadingRole': 'Cargando permisos del rol…',
  'settings.rolePerms.orphanTitle': 'Permisos no listados arriba',
  'settings.rolePerms.orphanSubtitle':
    'Están asignados al rol en la base de datos pero no aparecen en el catálogo activo (por ejemplo, permiso desactivado en enumerables). Puede quitarlos aquí o conservarlos hasta alinear el catálogo.',
  'settings.rolePerms.orphanRemoveAll': 'Quitar todos los no listados',
  'settings.rolePerms.groupOther': 'Otros',
  'settings.rolePerms.groups.tickets': 'Tickets',
  'settings.rolePerms.groups.reports': 'Informes',
  'settings.rolePerms.groups.admin': 'Administración',
  'settings.rolePerms.keys.view_all_tickets': 'Ver todos los tickets',
  'settings.rolePerms.keys.view_assigned_tickets': 'Ver tickets asignados',
  'settings.rolePerms.keys.view_client_tickets': 'Ver tickets de clientes',
  'settings.rolePerms.keys.view_own_tickets': 'Ver tickets propios',
  'settings.rolePerms.keys.create_ticket': 'Crear ticket',
  'settings.rolePerms.keys.edit_ticket': 'Editar ticket',
  'settings.rolePerms.keys.assign_ticket': 'Asignar ticket',
  'settings.rolePerms.keys.escalate_ticket': 'Escalar ticket',
  'settings.rolePerms.keys.resolve_ticket': 'Resolver ticket',
  'settings.rolePerms.keys.comment_ticket': 'Comentar en ticket',
  'settings.rolePerms.keys.view_reports': 'Ver informes',
  'settings.rolePerms.keys.manage_users': 'Gestionar usuarios y roles',
  'settings.rolePerms.keys.manage_plants': 'Gestionar plantas',
  'settings.rolePerms.keys.manage_clients': 'Gestionar clientes',
  'settings.rolePerms.keys.manage_contracts': 'Gestionar contratos',
  'settings.rolePerms.keys.configure_sla': 'Configurar reglas SLA',
  'settings.rolePerms.keys.view_audit_log': 'Ver registro de auditoría',
  'settings.rolePerms.keys.manage_enums': 'Gestionar enumerables',
  'settings.rolePerms.keys.delete_core_entities': 'Eliminar entidades (clientes, contratos, plantas…)',
  'settings.rolePerms.keys.delete_ticket': 'Eliminar tickets y adjuntos',
  'settings.rolePerms.keys.delete_reference_data': 'Eliminar datos de referencia (categorías, departamentos…)',
  'settings.sla.title': 'Reglas SLA por categoría y prioridad',
  'settings.sla.subtitle': 'Defina tiempos de respuesta y resolución para cada tipo de ticket',
  'settings.sla.addRule': 'Agregar regla SLA',
  'settings.sla.loading': 'Cargando reglas SLA...',
  'settings.sla.col.category': 'Categoría',
  'settings.sla.col.priority': 'Prioridad',
  'settings.sla.col.responseTime': 'Tiempo de respuesta',
  'settings.sla.col.resolutionTime': 'Tiempo de resolución',
  'settings.sla.col.escalation': 'Escalamiento',
  'settings.sla.col.department': 'Departamento',
  'settings.sla.col.autoAssign': 'Autoasignación',
  'settings.sla.col.actions': 'Acciones',
  'settings.sla.modal.addTitle': 'Agregar regla SLA',
  'settings.sla.modal.editTitle': 'Editar regla SLA',
  'settings.sla.form.categoryId': 'ID de categoría',
  'settings.sla.form.priority': 'Prioridad',
  'settings.sla.form.responseTime': 'Tiempo de respuesta (horas)',
  'settings.sla.form.resolutionTime': 'Tiempo de resolución (horas)',
  'settings.sla.form.escalationThreshold': 'Umbral de escalamiento (horas)',
  'settings.sla.form.departmentId': 'ID de departamento',
  'settings.sla.form.autoAssign': 'Habilitar autoasignación',
  'settings.sla.form.selectPriority': 'Seleccione prioridad',
  'settings.sla.form.saving': 'Guardando...',
  'settings.sla.form.addRule': 'Agregar regla SLA',
  'settings.sla.form.saveChanges': 'Guardar cambios',
  'settings.escalation.title': 'Reglas de escalamiento',
  'settings.escalation.subtitle': 'Disparadores y acciones de escalamiento automático',
  'settings.escalation.addRule': 'Agregar regla de escalamiento',
  'settings.escalation.loading': 'Cargando reglas de escalamiento...',
  'settings.escalation.trigger': 'Disparador',
  'settings.escalation.status': 'Transición de estado',
  'settings.escalation.department': 'Departamento',
  'settings.escalation.triggerDesc': 'Después de {hours} horas sin respuesta',
  'settings.escalation.allDepts': 'Todos los departamentos',
  'settings.escalation.modal.addTitle': 'Agregar regla de escalamiento',
  'settings.escalation.modal.editTitle': 'Editar regla de escalamiento',
  'settings.escalation.form.ruleName': 'Nombre de la regla',
  'settings.escalation.form.triggerHours': 'Horas de disparador',
  'settings.escalation.form.fromStatus': 'Estado de origen',
  'settings.escalation.form.toStatus': 'Estado de destino',
  'settings.escalation.form.status': 'Estado',
  'settings.escalation.form.saving': 'Guardando...',
  'settings.escalation.form.addRule': 'Agregar regla',
  'settings.escalation.form.saveChanges': 'Guardar cambios',
  'settings.notifications.title': 'Preferencias de notificación',
  'settings.notifications.subtitle': 'Configure cómo recibe las notificaciones',
  'settings.notifications.email': 'Notificaciones por correo',
  'settings.notifications.emailDesc': 'Reciba actualizaciones por correo electrónico',
  'settings.notifications.inApp': 'Notificaciones en la aplicación',
  'settings.notifications.inAppDesc': 'Reciba actualizaciones dentro de la plataforma',
  'settings.notifications.sms': 'Notificaciones SMS',
  'settings.notifications.smsDesc': 'Reciba alertas críticas por SMS',
  'settings.notifications.savePrefs': 'Guardar preferencias',
  'settings.notifications.saving': 'Guardando...',
  'settings.notifications.saved': 'Preferencias guardadas correctamente',
  'settings.notifications.saveFailed': 'No se pudieron guardar las preferencias',
  'settings.notifications.pref.ticketAssigned': 'Ticket asignado',
  'settings.notifications.pref.ticketEscalated': 'Ticket escalado',
  'settings.notifications.pref.ticketResolved': 'Ticket resuelto',
  'settings.notifications.pref.ticketComment': 'Comentario en ticket',
  'settings.notifications.pref.slaWarning': 'Advertencia de SLA',
  'settings.notifications.pref.dailyDigest': 'Resumen diario',
  'settings.notifications.pref.ticketCreated': 'Ticket creado',
  'settings.notifications.pref.criticalEscalation': 'Escalación crítica',
  'settings.notifications.pref.afterHoursEmergency': 'Emergencia fuera de horario',
  'settings.sla.allCategories': 'Todas',
  'settings.sla.form.optional': 'Opcional',
  'settings.sla.form.placeholderResponse': 'ej. 2',
  'settings.sla.form.placeholderResolution': 'ej. 24',
  'settings.sla.form.placeholderEscalation': 'ej. 18',
  'settings.escalation.ruleActive': 'Activo',
  'settings.escalation.ruleInactive': 'Inactivo',
  'settings.escalation.statusAny': 'Cualquiera',
  'settings.escalation.triggerLine': 'Tras {{hours}} horas sin respuesta',
  'settings.escalation.form.enterRuleName': 'Nombre de la regla',
  'settings.escalation.form.placeholderHours': 'ej. 4',
  'settings.escalation.form.fromPlaceholder': 'ej. new (opcional)',
  'settings.escalation.form.toPlaceholder': 'ej. escalated (opcional)',
  'settings.enums.permissionDenied':
    'No tiene permiso para agregar, editar o eliminar enumerables. Contacte a su administrador para solicitar el permiso "Gestionar enumerables".',
  'settings.enums.searchPlaceholder': 'Buscar clave o etiqueta…',
  'settings.enums.recordCount': '{{filtered}} de {{total}} registros',
  'settings.enums.addValue': 'Agregar valor',
  'settings.enums.noRecords': 'No se encontraron registros',
  'settings.enums.col.badge': 'Badge',
  'settings.enums.col.key': 'Clave',
  'settings.enums.col.group': 'Grupo',
  'settings.enums.col.order': 'Orden',
  'settings.enums.col.status': 'Estado',
  'settings.enums.col.type': 'Tipo',
  'settings.enums.col.actions': 'Acciones',
  'settings.enums.groupOther': 'Otros',
  'settings.enums.form.label': 'Etiqueta',
  'settings.enums.form.keySlug': 'Clave (slug)',
  'settings.enums.form.placeholderLabel': 'ej. En curso',
  'settings.enums.form.placeholderKey': 'ej. en_curso',
  'settings.enums.form.color': 'Color',
  'settings.enums.form.sortOrder': 'Orden',
  'settings.enums.form.group': 'Grupo',
  'settings.enums.form.groupPlaceholder': 'ej. Tickets, Admin, Informes',
  'settings.enums.form.icon': 'Icono',
  'settings.enums.preview': 'Vista previa:',
  'settings.enums.previewLabelFallback': 'Etiqueta',
  'settings.enums.previewKeyFallback': 'clave',
  'settings.enums.modal.newTitle': 'Nuevo valor — {{name}}',
  'settings.enums.modal.editTitle': 'Editar valor — {{name}}',
  'settings.enums.saveChanges': 'Guardar cambios',
  'settings.enums.deleteTitle': 'Eliminar valor',
  'settings.enums.deleteConfirm':
    '¿Quitar {{label}} de {{table}}? Los registros existentes que usen esta clave pueden dejar de funcionar.',
  'settings.enums.deleting': 'Eliminando...',
  'settings.enums.deleteBtn': 'Eliminar',
  'settings.enums.loading': 'Cargando registros...',
  'settings.enums.rowActive': 'Activo',
  'settings.enums.rowInactive': 'Inactivo',
  'settings.enums.typeSystem': 'Sistema',
  'settings.enums.typeCustom': 'Personalizado',
  'settings.enums.tables.priority.name': 'Prioridad',
  'settings.enums.tables.priority.desc': 'Niveles de prioridad de tickets y notificaciones',
  'settings.enums.tables.ticket_status.name': 'Estado del ticket',
  'settings.enums.tables.ticket_status.desc': 'Estados del ciclo de vida de un ticket',
  'settings.enums.tables.sla_status.name': 'Estado SLA',
  'settings.enums.tables.sla_status.desc': 'Estado de salud SLA derivado mostrado en tarjetas',
  'settings.enums.tables.contract_status.name': 'Estado del contrato',
  'settings.enums.tables.contract_status.desc': 'Estados del ciclo de vida de un contrato de cliente',
  'settings.enums.tables.payment_frequency.name': 'Frecuencia de pago',
  'settings.enums.tables.payment_frequency.desc': 'Opciones de ciclo de facturación para contratos',
  'settings.enums.tables.payment_status.name': 'Estado de pago',
  'settings.enums.tables.payment_status.desc': 'Situación de pago de un contrato o cliente',
  'settings.enums.tables.audit_severity.name': 'Severidad de auditoría',
  'settings.enums.tables.audit_severity.desc': 'Niveles de severidad para entradas del log de auditoría',
  'settings.enums.tables.notification_type.name': 'Tipo de notificación',
  'settings.enums.tables.notification_type.desc': 'Eventos que disparan una notificación',
  'settings.enums.tables.timeline_event_type.name': 'Tipo de evento de línea de tiempo',
  'settings.enums.tables.timeline_event_type.desc': 'Tipos de eventos que aparecen en el historial del ticket',
  'settings.enums.tables.notification_channel.name': 'Canal de notificación',
  'settings.enums.tables.notification_channel.desc': 'Canales de entrega de notificaciones',
  'settings.enums.tables.record_status.name': 'Estado de registro',
  'settings.enums.tables.record_status.desc':
    'Estado genérico activo/inactivo compartido por departamentos, roles, contactos, etc.',
  'settings.enums.tables.client_status.name': 'Estado del cliente',
  'settings.enums.tables.client_status.desc': 'Estado operativo de la cuenta de un cliente',
  'settings.enums.tables.plant_status.name': 'Estado de la planta',
  'settings.enums.tables.plant_status.desc': 'Estado operativo de una planta',
  'settings.enums.tables.service_frequency.name': 'Frecuencia de servicio',
  'settings.enums.tables.service_frequency.desc': 'Con qué frecuencia se presta un servicio en una planta',
  'settings.enums.tables.contract_type.name': 'Tipo de contrato',
  'settings.enums.tables.contract_type.desc': 'Nivel de cobertura asignado a una planta bajo contrato',
  'settings.enums.tables.industry.name': 'Industria',
  'settings.enums.tables.industry.desc': 'Sector empresarial de la compañía cliente',
  'settings.enums.tables.permission.name': 'Permiso',
  'settings.enums.tables.permission.desc': 'Acciones granulares que pueden asignarse a roles',
  'settings.enums.color.gray': 'Gris',
  'settings.enums.color.red': 'Rojo',
  'settings.enums.color.orange': 'Naranja',
  'settings.enums.color.yellow': 'Amarillo',
  'settings.enums.color.green': 'Verde',
  'settings.enums.color.teal': 'Verde azulado',
  'settings.enums.color.blue': 'Azul',
  'settings.enums.color.purple': 'Violeta',
  'settings.enums.color.pink': 'Rosa',

  'sla.health.on_track': 'En plazo',
  'sla.health.at_risk': 'En riesgo',
  'sla.health.overdue': 'Vencido',

  // ──────────────────────────────────────────────
  // SHARED: PRIORITIES & STATUSES
  // ──────────────────────────────────────────────
  'priority.low': 'Baja',
  'priority.medium': 'Media',
  'priority.high': 'Alta',
  'priority.critical': 'Crítica',
  'priority.low.time': '3 días',
  'priority.medium.time': '2 días',
  'priority.high.time': '1 día',
  'priority.critical.time': '8 horas',
  'status.new': 'Nuevo',
  'status.in_progress': 'En progreso',
  'status.waiting': 'En espera',
  'status.escalated': 'Escalado',
  'status.resolved': 'Resuelto',
  'status.closed': 'Cerrado',
  'status.client_confirmed': 'Confirmado por cliente',
  'status.reopened': 'Reabierto',

  // ──────────────────────────────────────────────
  // PORTAL REVIEW
  // ──────────────────────────────────────────────
  'portalReview.title': 'Revisión de ticket',
  'portalReview.loading': 'Cargando ticket...',
  'portalReview.notAvailable': 'Este ticket no está disponible para revisión.',
  'portalReview.notAvailableDesc': 'El enlace puede haber caducado o el ticket ya fue resuelto.',
  'portalReview.alreadyConfirmed': '¡Gracias! Ya confirmaste este ticket como resuelto.',
  'portalReview.alreadyReopened': 'Tu ticket ya fue reabierto. Nuestro equipo te contactará.',
  'portalReview.closed.heading': 'Tu ticket ha sido cerrado',
  'portalReview.closed.subheading': 'Por favor indícanos si el problema fue resuelto satisfactoriamente.',
  'portalReview.ticket': 'Ticket',
  'portalReview.confirm.heading': 'Confirmar resolución',
  'portalReview.confirm.description': 'Si el problema fue completamente resuelto, haz clic para confirmar.',
  'portalReview.confirm.button': 'Sí, confirmar resolución',
  'portalReview.confirm.loading': 'Confirmando...',
  'portalReview.confirm.success': '¡Gracias! Tu confirmación ha sido registrada.',
  'portalReview.reopen.heading': 'Reabrir ticket',
  'portalReview.reopen.description': 'Si el problema no fue completamente resuelto, puedes reabrir este ticket.',
  'portalReview.reopen.commentLabel': '¿Qué sigue sin resolverse?',
  'portalReview.reopen.commentPlaceholder': 'Describe qué necesita atención...',
  'portalReview.reopen.button': 'Reabrir ticket',
  'portalReview.reopen.loading': 'Reabriendo...',
  'portalReview.reopen.success': 'Tu ticket fue reabierto. Nuestro equipo te contactará pronto.',
  'portalReview.error': 'Ocurrió un error. Por favor intenta de nuevo.',

  // ──────────────────────────────────────────────
  // SHARED: VALIDATION
  // ──────────────────────────────────────────────
  'validation.nameRequired': 'El nombre es obligatorio',
  'validation.plantRequired': 'Debe seleccionar al menos una planta',
  'validation.categoryRequired': 'La categoría es obligatoria',
  'validation.subjectRequired': 'El asunto es obligatorio',
  'validation.descriptionRequired': 'La descripción es obligatoria',
  'validation.priorityRequired': 'La prioridad es obligatoria',
  'validation.clientRequired': 'El cliente es obligatorio',
  'validation.confirmRequired': 'Debe confirmar que la información es correcta',
  'validation.selectPlant': 'Seleccione una planta',

  // ──────────────────────────────────────────────
  // PUBLIC TICKET / PORTAL
  // ──────────────────────────────────────────────
  'portal.title': 'Enviar un ticket',
  'portal.subtitle': 'Complete el formulario para enviar su solicitud',
  'portal.description': 'Envíe un nuevo ticket, consulte uno existente o inicie sesión para ver su historial completo',
  'portal.tabs.submit': 'Enviar Ticket',
  'portal.tabs.submitShort': 'Enviar',
  'portal.tabs.track': 'Rastrear Ticket',
  'portal.tabs.trackShort': 'Rastrear',
  'portal.tabs.portal': 'Mi Portal',
  'portal.tabs.portalShort': 'Portal',
  'portal.openTicketsTooltip': 'Tus tickets abiertos (creados con tu usuario): {{count}}',

  // Quick Lookup
  'portal.quickLookup.title': 'Búsqueda rápida de ticket',
  'portal.quickLookup.subtitle': 'Consultá el estado de cualquier ticket al instante — sin iniciar sesión',
  'portal.quickLookup.placeholder': 'ej.: TK-001',
  'portal.quickLookup.search': 'Buscar',
  'portal.quickLookup.searching': 'Buscando...',
  'portal.quickLookup.notFound': 'No hay ticket "{{id}}". Revisá el formato TK-001.',
  'portal.quickLookup.searchAnother': 'Buscar otro ticket',
  'portal.quickLookup.resolvedOn': 'Resuelto el {{date}}',

  // Contact Verification
  'portal.verify.title': 'Verificación de contacto',
  'portal.verify.description': 'Solo contactos autorizados pueden crear tickets. Ingresá tu email registrado para continuar. No se necesita contraseña para enviar. Para acceso completo al portal (perfil, historial de tickets), usá <strong>Mi Portal</strong> con tu contraseña.',
  'portal.verify.emailLabel': 'Correo electrónico',
  'portal.verify.placeholder': 'tu.email@empresa.com',
  'portal.verify.verifying': 'Verificando...',
  'portal.verify.verifyBtn': 'Verificar y continuar',
  'portal.verify.emailNotFound': 'Email no encontrado',
  'portal.verify.emailNotFoundDesc': 'No se encontró un contacto autorizado con este email. Intente de nuevo o contacte a su representante de Cysol.',
  'portal.verify.authError': 'Error de autenticación',
  'portal.verify.authErrorDefault': 'No pudimos validar sus credenciales en este momento. Intente más tarde.',
  'portal.verify.authForbidden': 'Su cuenta no está autorizada para enviar tickets. Contacte a su representante de Cysol.',

  // Common
  'common.back': 'Volver',

  // Verified Banner
  'portal.verified.title': 'Contacto autorizado verificado',
  'portal.verified.welcome': 'Bienvenido/a, {{name}}. Ahora puede enviar un ticket de servicio.',

  // Submit Form
  'portal.form.reporterInfo': 'Información del solicitante',
  'portal.form.yourName': 'Tu nombre',
  'portal.form.emailAddress': 'Correo electrónico',
  'portal.form.company': 'Empresa',
  'portal.form.plantSelection': 'Selección de planta',
  'portal.form.selectPlant': 'Seleccionar planta',
  'portal.form.noPlantsAvailable': 'No hay plantas disponibles para tu cuenta.',
  'portal.form.issueDetails': 'Detalles del problema',
  'portal.form.issueCategory': 'Categoría del problema',
  'portal.form.selectCategory': 'Seleccionar una categoría',
  'portal.form.assignedTo': 'Se asignará a:',
  'portal.form.priorityLevel': 'Nivel de prioridad',
  'portal.form.subject': 'Asunto',
  'portal.form.subjectPlaceholder': 'Resumen breve del problema',
  'portal.form.description': 'Descripción detallada',
  'portal.form.descriptionPlaceholder': 'Proporcione una descripción detallada del problema...',
  'portal.form.attachments': 'Adjuntos',
  'portal.form.attachmentsOptional': 'Opcional',
  'portal.form.dragDrop': 'Arrastre archivos aquí, o haga clic para seleccionar',
  'portal.form.chooseFiles': 'Elegir archivos',
  'portal.form.supportedFormats': 'Soportados: PDF, Imágenes, Excel, Word (Máx. 10MB por archivo)',
  'portal.form.contactPreference': 'Preferencia de contacto',
  'portal.form.preferredMethod': 'Método de contacto preferido',
  'portal.form.confirmAccuracyText': 'Confirmo que la información proporcionada es precisa y completa. Entiendo que este ticket se procesará según el nivel de prioridad seleccionado.',
  'portal.form.submitting': 'Enviando...',
  'portal.form.submitTicket': 'Enviar ticket de servicio',
  'portal.form.submitError': 'Error al enviar el ticket. Intente de nuevo.',

  // Submit Success
  'portal.success.title': '¡Ticket enviado exitosamente!',
  'portal.success.subtitle': 'Su solicitud de servicio fue recibida y será procesada en breve.',
  'portal.success.ticketId': 'ID del ticket',
  'portal.success.status': 'Estado',
  'portal.success.submittedBy': 'Enviado por',
  'portal.success.plants': 'Planta(s)',
  'portal.success.category': 'Categoría',
  'portal.success.priority': 'Prioridad',
  'portal.success.department': 'Departamento asignado',
  'portal.success.expectedResponse': 'Primera respuesta esperada',
  'portal.success.subject': 'Asunto',
  'portal.success.whatNext': '¿Qué sigue?',
  'portal.success.nextItem1': 'Su ticket fue asignado al departamento de {{dept}}',
  'portal.success.nextItem2': 'Recibirá actualizaciones por {{method}}',
  'portal.success.nextItem3': 'Primera respuesta esperada: {{time}}',
  'portal.success.nextItem4': 'Conserve su ID de ticket como referencia: <strong>{{id}}</strong>',
  'portal.success.submitAnother': 'Enviar otro ticket',

  // Track
  'portal.track.title': 'Rastrear tu ticket',
  'portal.track.description': 'Ingresá el ID del ticket con el formato <strong>TK-000</strong> (el que recibiste al crear el ticket).',
  'portal.track.ticketNumberLabel': 'Número de ticket',
  'portal.track.placeholder': 'ej.: TK-001',
  'portal.track.searching': 'Buscando...',
  'portal.track.trackBtn': 'Rastrear ticket',
  'portal.track.ticketDetails': 'Detalles del ticket',
  'portal.track.searchAnother': 'Buscar otro',
  'portal.track.client': 'Cliente',
  'portal.track.plant': 'Planta',
  'portal.track.category': 'Categoría',
  'portal.track.priority': 'Prioridad',
  'portal.track.submittedOn': 'Enviado el',
  'portal.track.expectedResolution': 'Resolución esperada',
  'portal.track.resolvedOn': 'Resuelto el',
  'portal.track.notAvailable': 'No disponible',
  'portal.track.resolved.title': 'Ticket resuelto',
  'portal.track.resolved.description': 'Este ticket fue resuelto exitosamente. Si tiene más preguntas, envíe un nuevo ticket.',
  'portal.track.activityTimeline': 'Línea de tiempo',
  'portal.track.notFound.title': 'Ticket no encontrado',
  'portal.track.notFound.description': 'No encontramos un ticket <strong>{{id}}</strong>. Revisá el formato (TK-001).',
  'portal.track.notFound.tips': 'Consejos',
  'portal.track.notFound.tip1': 'Debés usar el formato <strong>TK-000</strong>, no solo el número',
  'portal.track.notFound.tip2': 'Es el mismo código que figura al enviar el ticket',
  'portal.track.tryAgain': 'Intentar de nuevo',

  // Portal Login
  'portal.login.title': 'Portal de Cliente',
  'portal.login.subtitle': 'Inicie sesión para ver sus tickets',
  'portal.login.emailLabel': 'Correo electrónico',
  'portal.login.emailPlaceholder': 'tu.email@empresa.com',
  'portal.login.passwordLabel': 'Contraseña',
  'portal.login.passwordPlaceholder': 'Ingrese su contraseña',
  'portal.login.error401': 'Email o contraseña inválidos, o su cuenta está inactiva. Intente de nuevo.',
  'portal.login.error403': 'Su cuenta no está autorizada para acceder al portal. Contacte a su representante de Cysol.',
  'portal.login.errorGeneric': 'Error al iniciar sesión. Intente más tarde.',
  'portal.login.signingIn': 'Iniciando sesión...',
  'portal.login.signIn': 'Iniciar sesión en el portal',

  // My Portal (ClientTicketPortal)
  'portal.myPortal.clientContact': 'Contacto de cliente',
  'portal.myPortal.newTicket': 'Nuevo Ticket',
  'portal.myPortal.signOut': 'Cerrar sesión',
  'portal.myPortal.totalTickets': 'Total de tickets',
  'portal.myPortal.open': 'Abiertos',
  'portal.myPortal.escalated': 'Escalados',
  'portal.myPortal.resolved': 'Resueltos',
  'portal.myPortal.escalationAlert': '{{count}} ticket(s) vencido(s) requieren atención',
  'portal.myPortal.urgent': 'URGENTE',
  'portal.myPortal.escalationDesc': 'Los siguientes tickets superaron su fecha límite de SLA. Nuestro equipo está trabajando para resolverlos con prioridad máxima.',
  'portal.myPortal.myTickets': 'Mis tickets',
  'portal.myPortal.searchPlaceholder': 'Buscar por TK-001, título o planta...',
  'portal.myPortal.allStatuses': 'Todos los estados',
  'portal.myPortal.noTickets': 'No se encontraron tickets',
  'portal.myPortal.adjustFilters': 'Intente ajustar sus filtros',
  'portal.myPortal.showing': 'Mostrando {{count}} de {{total}} tickets',
  'portal.myPortal.submitNewTicket': 'Enviar nuevo ticket',
  'portal.myPortal.overdue': 'Vencido',
  'portal.myPortal.hoursOverdue': '{{hours}}h vencido',
  'portal.myPortal.loadingTickets': 'Cargando tickets...',

  // My Portal - Ticket Detail
  'portal.myPortal.detail.backToTickets': 'Volver a Mis tickets',
  'portal.myPortal.detail.plant': 'Planta',
  'portal.myPortal.detail.category': 'Categoría',
  'portal.myPortal.detail.department': 'Departamento',
  'portal.myPortal.detail.assignedTo': 'Asignado a',
  'portal.myPortal.detail.unassigned': 'Sin asignar',
  'portal.myPortal.detail.submitted': 'Enviado',
  'portal.myPortal.detail.priority': 'Prioridad',
  'portal.myPortal.detail.slaOverdue': 'SLA Vencido — Escalado',
  'portal.myPortal.detail.slaOverdueDesc': 'Este ticket tiene <strong>{{hours}} horas de retraso</strong>. Fue escalado a la administración y se está manejando con máxima prioridad.',
  'portal.myPortal.detail.ticketResolved': 'Ticket resuelto',
  'portal.myPortal.detail.resolvedOn': 'Resuelto el {{date}}.',
  'portal.myPortal.detail.activityTimeline': 'Línea de tiempo',
  'portal.myPortal.detail.events': '{{count}} eventos',
  'portal.myPortal.detail.ticketClosed': 'Ticket Cerrado \u2014 Esperando tu Revisi\u00f3n',
  'portal.myPortal.detail.ticketClosedDesc': 'Nuestro equipo ha cerrado este ticket. Por favor confirma que fue resuelto o solicita una reapertura si el problema contin\u00faa.',
  'portal.myPortal.detail.reviewOrReopen': 'Confirmar o Reabrir',

  // My Portal - New Ticket Form
  'portal.myPortal.newForm.title': 'Nuevo Ticket',
  'portal.myPortal.newForm.reporterInfo': 'Información del solicitante (pre-llena)',
  'portal.myPortal.newForm.name': 'Nombre',
  'portal.myPortal.newForm.email': 'Email',
  'portal.myPortal.newForm.company': 'Empresa',
  'portal.myPortal.newForm.role': 'Rol',
  'portal.myPortal.newForm.clientContact': 'Contacto de cliente',
  'portal.myPortal.newForm.plant': 'Planta',
  'portal.myPortal.newForm.issueCategory': 'Categoría del problema',
  'portal.myPortal.newForm.selectCategory': 'Seleccionar una categoría',
  'portal.myPortal.newForm.assignedTo': 'Asignado a:',
  'portal.myPortal.newForm.priority': 'Prioridad',
  'portal.myPortal.newForm.subject': 'Asunto',
  'portal.myPortal.newForm.subjectPlaceholder': 'Resumen breve del problema',
  'portal.myPortal.newForm.description': 'Descripción',
  'portal.myPortal.newForm.descriptionPlaceholder': 'Describa el problema en detalle...',
  'portal.myPortal.newForm.attachments': 'Adjuntos',
  'portal.myPortal.newForm.attachmentsOptional': 'opcional',
  'portal.myPortal.newForm.dropFiles': 'Soltar archivos aquí o <1>seleccionar</1>',
  'portal.myPortal.newForm.dropFilesText': 'Soltar archivos aquí o',
  'portal.myPortal.newForm.browse': 'seleccionar',
  'portal.myPortal.newForm.fileFormats': 'PDF, Imágenes, Excel, Word — máx. 10 MB cada uno',
  'portal.myPortal.newForm.filesSelected': '{{count}} archivo(s) seleccionado(s)',
  'portal.myPortal.newForm.ticketFor': 'El ticket será enviado para:',
  'portal.myPortal.newForm.submitting': 'Enviando...',
  'portal.myPortal.newForm.submitTicket': 'Enviar Ticket',
  'portal.myPortal.newForm.submitError': 'Error al enviar el ticket. Intente de nuevo.',
  'portal.myPortal.newForm.success.title': '¡Ticket enviado!',
  'portal.myPortal.newForm.success.subtitle': 'Su solicitud fue recibida y asignada a nuestro equipo.',
  'portal.myPortal.newForm.success.ticketId': 'Su ID de ticket',
  'portal.myPortal.newForm.success.filesAttached': '{{count}} archivo(s) adjunto(s)',
  'portal.myPortal.newForm.success.confirmationSent': 'Se envió una confirmación a <strong>{{email}}</strong>',
  'portal.myPortal.newForm.success.backToTickets': 'Volver a Mis tickets',
  'portal.myPortal.newForm.loadingFormData': 'Cargando datos del formulario...',

  // ──────────────────────────────────────────────
  // CREATE TICKET (Admin)
  // ──────────────────────────────────────────────
  'createTicket.subtitle': 'Envíe una queja o solicitud de servicio para su planta industrial',
  'createTicket.backToTickets': 'Volver a Tickets',
  'createTicket.ticketTargetType': '¿Para qué es este ticket?',
  'createTicket.ticketTargetTypeHint':
    'Elija un cliente y planta, o un departamento interno (ticket sin cliente ni planta).',
  'createTicket.targetClient': 'Empresa cliente y planta',
  'createTicket.targetInternalDepartment': 'Departamento interno',
  'createTicket.internalDeptSection': 'Departamento interno',
  'createTicket.internalDeptHelp':
    'El ticket queda en la cola de esa área. Se asigna automáticamente al primer usuario activo del departamento (por orden de nombre) si existe; si no, queda sin asignar.',
  'createTicket.internalDepartment': 'Departamento',
  'createTicket.selectInternalDepartment': 'Seleccionar departamento',
  'createTicket.categoryHintInternal':
    'En tickets internos la categoría no cambia el departamento — use el departamento elegido arriba.',
  'createTicket.internalDeptLocked': 'Departamento: {{name}} (según su selección)',
  'createTicket.contactNotApplicableInternal': 'No aplica — ticket interno (sin contacto de planta).',
  'createTicket.validation.internalDepartmentRequired': 'Seleccione un departamento para el ticket interno.',
  'createTicket.clientInfo': 'Información del cliente',
  'createTicket.clientCompany': 'Empresa cliente',
  'createTicket.selectClient': 'Seleccionar un cliente',
  'createTicket.plantSelection': 'Selección de planta',
  'createTicket.howManyPlants': '¿Cuántas plantas afecta este ticket?',
  'createTicket.singlePlant': 'Una planta',
  'createTicket.multiplePlants': 'Varias plantas',
  'createTicket.selectClientFirst': 'Seleccione un cliente primero',
  'createTicket.selectClientFirstPlants': 'Seleccione un cliente primero para ver las plantas disponibles',
  'createTicket.noPlantsFound': 'No se encontraron plantas para este cliente',
  'createTicket.selectPlants': 'Seleccionar planta(s)',
  'createTicket.ticketDetails': 'Detalles del ticket',
  'createTicket.category': 'Categoría',
  'createTicket.selectCategory': 'Seleccionar una categoría',
  'createTicket.assignedToDept': 'Se asignará a:',
  'createTicket.department': 'Departamento',
  'createTicket.selectDepartment': 'Seleccionar un departamento',
  'createTicket.assignee': 'Asignado',
  'createTicket.autoAssigned': 'Auto-asignado',
  'createTicket.otherDepartments': 'Otros departamentos',
  'createTicket.selectAssignee': 'Seleccionar un asignado',
  'createTicket.contact': 'Contacto',
  'createTicket.selectContact': 'Seleccionar un contacto',
  'createTicket.noContactsFound': 'No se encontraron contactos para este cliente',
  'createTicket.selectClientFirstContacts': 'Selecciona primero un cliente',
  'createTicket.priority': 'Prioridad',
  'createTicket.estimatedResponse': 'Tiempo estimado de respuesta:',
  'createTicket.subject': 'Asunto',
  'createTicket.subjectPlaceholder': 'Resumen breve del problema',
  'createTicket.description': 'Descripción detallada',
  'createTicket.descriptionPlaceholder': 'Proporcione una descripción detallada, incluyendo contexto, impacto y urgencia...',
  'createTicket.attachments': 'Adjuntos',
  'createTicket.attachmentsOptional': 'Opcional',
  'createTicket.dragDrop': 'Arrastre archivos aquí, o haga clic para seleccionar',
  'createTicket.chooseFiles': 'Elegir archivos',
  'createTicket.supportedFormats': 'Soportados: PDF, Imágenes, Excel, Word (Máx. 10MB por archivo)',
  'createTicket.cancel': 'Cancelar',
  'createTicket.creating': 'Creando...',
  'createTicket.creatingTicket': 'Creando ticket...',
  'createTicket.creatingForPlant': 'Creando ticket para {{plant}} ({{current}}/{{total}})...',
  'createTicket.uploadingAttachments': 'Subiendo adjuntos...',
  'createTicket.uploadingFile': 'Subiendo archivo {{current}} de {{total}}: {{name}}',
  'createTicket.uploadComplete': 'Subido correctamente',
  'createTicket.uploadFailed': 'Error al subir',
  'createTicket.uploadPartialWarning': 'Ticket creado, pero {{count}} archivo(s) no se pudieron subir. Puede reintentarlo desde el detalle del ticket.',
  'createTicket.loading': 'Cargando...',
  'createTicket.createTicket': 'Crear Ticket',
  'createTicket.retry': 'Reintentar',
  'createTicket.unknownError': 'Error desconocido',
  'createTicket.createFailed': 'No se pudo crear el ticket',
  'createTicket.loadError': 'Error al cargar datos del formulario: {{msg}}. Asegúrese de que la API esté funcionando y de haber iniciado sesión.',
  'createTicket.success.title': '¡Ticket creado exitosamente!',
  'createTicket.success.subtitle': 'Su queja fue enviada y asignada al equipo correspondiente.',
  'createTicket.success.ticketId': 'ID del ticket',
  'createTicket.success.status': 'Estado',
  'createTicket.success.client': 'Cliente',
  'createTicket.success.internalClientLabel': 'Interno (sin cliente)',
  'createTicket.success.internalPlantLabel': '—',
  'createTicket.success.plants': 'Planta(s)',
  'createTicket.success.category': 'Categoría',
  'createTicket.success.priority': 'Prioridad',
  'createTicket.success.department': 'Departamento asignado',
  'createTicket.success.estimatedResponse': 'Respuesta estimada',
  'createTicket.success.subject': 'Asunto',
  'createTicket.success.whatNext': '¿Qué sigue?',
  'createTicket.success.nextItem1': 'El departamento asignado fue notificado',
  'createTicket.success.nextItem2': 'Recibirá actualizaciones por email',
  'createTicket.success.nextItem3': 'Siga el progreso en la sección de Tickets',
  'createTicket.success.nextItem4': 'Primera respuesta esperada: {{time}}',
  'createTicket.success.viewAllTickets': 'Ver todos los tickets',
  'createTicket.success.createAnother': 'Crear otro ticket',

  // ──────────────────────────────────────────────
  // SERVICE TYPES
  // ──────────────────────────────────────────────
  'serviceTypes.title': 'Tipos de servicio',
  'serviceTypes.subtitle': 'Administre los tipos de servicio disponibles',
  'serviceTypes.addNew': 'Agregar tipo de servicio',
  'serviceTypes.manageDesc': 'Administre el catálogo de servicios ofrecidos en contratos',
  'serviceTypes.addModalDesc': 'Agregar un nuevo tipo de servicio al catálogo',
  'serviceTypes.keyHint': 'Uso interno en contratos. Solo minúsculas y guiones.',
  'serviceTypes.namePlaceholder': 'ej. Limpieza industrial',
  'serviceTypes.keyPlaceholder': 'ej. limpieza-industrial',
  'serviceTypes.descPlaceholder': 'Breve descripción de este tipo de servicio…',
  'serviceTypes.notFoundTitle': 'No hay tipos de servicio',
  'serviceTypes.notFoundDesc': 'Intente ajustar la búsqueda o los filtros',
  'serviceTypes.newBtn': 'Nuevo tipo de servicio',
  'serviceTypes.stats.totalTypes': 'Total de tipos',
  'serviceTypes.stats.active': 'Activos',
  'serviceTypes.stats.inactive': 'Inactivos',
  'serviceTypes.allStatuses': 'Todos los estados',
  'serviceTypes.clear': 'Limpiar',
  'serviceTypes.countOf': '{{shown}} de {{total}}',
  'serviceTypes.col.serviceType': 'Tipo de servicio',
  'serviceTypes.col.key': 'Clave',
  'serviceTypes.col.description': 'Descripción',
  'serviceTypes.col.status': 'Estado',
  'serviceTypes.col.created': 'Creado',
  'serviceTypes.col.actions': 'Acciones',
  'serviceTypes.showingTypes': 'Mostrando {{shown}} de {{total}} tipos de servicio',
  'serviceTypes.modal.newTitle': 'Nuevo tipo de servicio',
  'serviceTypes.modal.editTitle': 'Editar tipo de servicio',
  'serviceTypes.form.name': 'Nombre',
  'serviceTypes.form.key': 'Clave (slug)',
  'serviceTypes.form.description': 'Descripción',
  'serviceTypes.form.icon': 'Icono',
  'serviceTypes.form.color': 'Color',
  'serviceTypes.form.preview': 'Vista previa:',
  'serviceTypes.form.previewFallback': 'Tipo de servicio',
  'serviceTypes.form.status': 'Estado',
  'serviceTypes.createBtn': 'Crear tipo de servicio',
  'serviceTypes.deleteTitle': 'Eliminar tipo de servicio',
  'serviceTypes.deleteConfirm':
    '¿Seguro que desea eliminar "{{name}}"? Esta acción no se puede deshacer.',
  'serviceTypes.err.statusUpdate': 'Error al actualizar el estado',
  'serviceTypes.err.load': 'Error al cargar los tipos de servicio',
  'serviceTypes.err.create': 'Error al crear el tipo de servicio',
  'serviceTypes.err.update': 'Error al actualizar el tipo de servicio',
  'serviceTypes.err.delete': 'Error al eliminar el tipo de servicio',
  'serviceTypes.searchPlaceholder': 'Buscar por nombre, clave o descripción…',
  'serviceTypes.deleting': 'Eliminando…',
  'serviceTypes.icon.water': 'Agua / Limpieza',
  'serviceTypes.icon.tools': 'Herramientas',
  'serviceTypes.icon.shield': 'Escudo',
  'serviceTypes.icon.graduation': 'Gorro de graduación',
  'serviceTypes.icon.lightbulb': 'Bombilla',
  'serviceTypes.icon.hammer': 'Martillo',
  'serviceTypes.icon.settings': 'Ajustes',
  'serviceTypes.icon.recycle': 'Reciclaje',
  'serviceTypes.icon.leaf': 'Hoja',
  'serviceTypes.icon.barChart': 'Gráfico de barras',
  'serviceTypes.icon.fileText': 'Archivo de texto',
  'serviceTypes.icon.alert': 'Alerta',

  // ──────────────────────────────────────────────
  // PROFILE MODAL
  // ──────────────────────────────────────────────
  'profile.err.nameRequired': 'El nombre es obligatorio',
  'profile.err.emailRequired': 'El correo es obligatorio',
  'profile.err.emailInvalid': 'Formato de correo no válido',
  'profile.err.newPasswordRequired': 'La nueva contraseña es obligatoria',
  'profile.err.passwordMin8': 'La contraseña debe tener al menos 8 caracteres',
  'profile.err.confirmPassword': 'Confirme su contraseña',
  'profile.err.passwordMismatch': 'Las contraseñas no coinciden',
  'profile.toast.updated': 'Perfil actualizado correctamente',
  'profile.toast.updateFailed': 'No se pudo actualizar el perfil',
  'profile.toast.comingSoon': 'Próximamente',
  'profile.prefs.emailNotifications': 'Notificaciones por correo',
  'profile.prefs.emailNotificationsDesc': 'Recibir actualizaciones por correo de todas las actividades',
  'profile.prefs.escalationAlerts': 'Alertas de escalamiento',
  'profile.prefs.escalationAlertsDesc': 'Aviso cuando se escalen tickets',
  'profile.prefs.ticketAssignments': 'Asignaciones de tickets',
  'profile.prefs.ticketAssignmentsDesc': 'Avisarme cuando me asignen tickets',
  'profile.prefs.weeklyDigest': 'Resumen semanal',
  'profile.prefs.weeklyDigestDesc': 'Recibir un resumen semanal de las actividades',
  'profile.prefs.clientUpdates': 'Actualizaciones al cliente',
  'profile.prefs.clientUpdatesDesc': 'Aviso de actualizaciones visibles para el cliente',
  'profile.changePhoto': 'Cambiar foto',
  'profile.editTitle': 'Editar perfil',
  'profile.imageAlt': 'Perfil',
  'profile.currentPasswordPlaceholder': 'Contraseña actual para cambiar',
  'profile.sectionPersonal': 'Información personal',
  'profile.sectionNotifications': 'Preferencias de notificación',
  'profile.sectionSecurity': 'Seguridad',
  'profile.phoneNumber': 'Teléfono',
  'profile.jobTitle': 'Cargo',
  'profile.photoHint': 'JPG, PNG o GIF. Máx. 2 MB.',
  'profile.currentPassword': 'Contraseña actual',
  'profile.passwordHintMin8': 'La contraseña debe tener al menos 8 caracteres',

  // ──────────────────────────────────────────────
  // REPORTS
  // ──────────────────────────────────────────────
  'reports.title': 'Reportes',
  'reports.subtitle': 'Análisis y reportes del sistema de tickets',
  'reports.metricsSubtitle': 'Métricas integrales y análisis de desempeño',
  'reports.exportReport': 'Exportar reporte',
  'reports.loading': 'Cargando reportes…',
  'reports.loadError': 'Error al cargar reportes',
  'reports.periodLabel': 'Período del reporte:',
  'reports.periodLast4Weeks': 'Últimas 4 semanas',
  'reports.periodLast5Months': 'Últimos 5 meses',
  'reports.periodCustom': 'Rango personalizado',
  'reports.dateTo': 'a',
  'reports.kpi.totalTickets': 'Total de tickets',
  'reports.kpi.thisPeriod': 'Este período',
  'reports.kpi.resolutionRate': 'Tasa de resolución',
  'reports.kpi.resolvedOf': '{{resolved}} de {{total}} resueltos',
  'reports.kpi.avgResolution': 'Tiempo medio de resolución',
  'reports.kpi.avgAcrossTickets': 'Promedio en todos los tickets',
  'reports.kpi.slaCompliance': 'Cumplimiento SLA',
  'reports.kpi.withinSla': 'Dentro de los objetivos SLA',
  'reports.trendTitle': 'Tendencia de reclamos',
  'reports.totalLabel': 'Total:',
  'reports.resolvedLabel': 'Resueltos:',
  'reports.openLabel': 'Abiertos:',
  'reports.legendTotal': 'Total de tickets',
  'reports.legendResolved': 'Resueltos',
  'reports.legendOpen': 'Abiertos',
  'reports.avgResolutionByCategory': 'Tiempo medio de resolución por categoría',
  'reports.ticketsCount': '{{count}} tickets',
  'reports.complaintsByStatus': 'Reclamos por estado',
  'reports.deptPerformance': 'Desempeño por departamento',
  'reports.col.department': 'Departamento',
  'reports.col.ticketsHandled': 'Tickets atendidos',
  'reports.col.resolved': 'Resueltos',
  'reports.col.completionRate': 'Tasa de finalización',
  'reports.col.performance': 'Desempeño',
  'reports.complaintsByPlant': 'Reclamos por planta / cliente',
  'reports.topDepts': 'Departamentos con mejor desempeño',
  'reports.resolvedCount': '{{count}} resueltos',
  'reports.totalShort': '{{count}} en total',
  'reports.rateLabel': 'Tasa: {{rate}}%',
  'reports.escalationTitle': 'Análisis de escalamiento',
  'reports.atRiskLabel': 'En riesgo:',
  'reports.actionRequired': 'Acción requerida',
  'reports.escalationWarning':
    '{{count}} ticket(s) en riesgo o vencidos. Revise la carga y la asignación de recursos.',
  'reports.export.summary': 'Resumen',
  'reports.export.metricValue': 'Métrica,Valor',
  'reports.export.totalTickets': 'Total de tickets',
  'reports.export.resolutionRate': 'Tasa de resolución',
  'reports.export.avgResolution': 'Tiempo medio de resolución',
  'reports.export.slaCompliance': 'Cumplimiento SLA',
  'reports.export.statusBreakdown': 'Desglose por estado',
  'reports.export.statusCount': 'Estado,Cantidad',
  'reports.export.byCategory': 'Por categoría',
  'reports.export.categoryRow': 'Categoría,Total,Abiertos,Resueltos,Cerrados',
  'reports.export.byDepartment': 'Por departamento',
  'reports.export.deptRow': 'Departamento,Total,Abiertos,Resueltos,Cerrados',
  'reports.export.byClient': 'Por cliente',
  'reports.export.clientRow': 'Cliente,Total,Abiertos,Resueltos,Cerrados',

  // ──────────────────────────────────────────────
  // FILE UPLOAD (shared)
  // ──────────────────────────────────────────────
  'fileUpload.dragDrop': 'Arrastre archivos aquí o haga clic para buscar',
  'fileUpload.chooseFiles': 'Elegir archivos',
  'fileUpload.supportedAccept': 'Admitidos: {{accept}} (máx. {{maxSize}} MB por archivo)',
  'fileUpload.allTypesMax': 'Todos los tipos (máx. {{maxSize}} MB por archivo)',

  // ──────────────────────────────────────────────
  // TICKETS
  // ──────────────────────────────────────────────
  'tickets.title': 'Tickets',
  'tickets.createNew': 'Crear nuevo ticket',
  'tickets.newTicket': 'Nuevo ticket',
  'tickets.allStatus': 'Todos los estados',
  'tickets.allPriorities': 'Todas las prioridades',
  'tickets.allClients': 'Todos los clientes',
  'tickets.loading': 'Cargando tickets...',
  'tickets.notFound': 'No se encontraron tickets',
  'tickets.subtitle': 'Gestione y haga seguimiento de todos los tickets de reclamos',
  'tickets.export': 'Exportar Excel',
  'tickets.exportExcel': 'Exportar Excel',
  'tickets.exporting': 'Exportando...',
  'tickets.exportModal.title': 'Opciones de exportación a Excel',
  'tickets.exportModal.desc': 'Los demás filtros de la lista (cliente, estado, vigencia, etc.) se aplican al exportar todos los tickets.',
  'tickets.exportModal.ticketScope': '¿Qué tickets exportar?',
  'tickets.exportModal.scopeSelected': 'Solo los seleccionados',
  'tickets.exportModal.scopeSelectedHint': '{{count}} ticket(s) marcado(s) en la tabla',
  'tickets.exportModal.scopeSelectedEmpty': 'Marque tickets en la tabla para usar esta opción',
  'tickets.exportModal.scopeAllFiltered': 'Todos con los filtros actuales',
  'tickets.exportModal.scopeAllFilteredHint': 'Hasta {{count}} ticket(s) según búsqueda y filtros del listado',
  'tickets.exportModal.noSelection': 'Seleccione al menos un ticket o elija exportar todos',
  'tickets.exportModal.sheetMode': 'Organización del archivo',
  'tickets.exportModal.modeSingle': 'Una sola hoja',
  'tickets.exportModal.modeByDepartment': 'Una hoja por departamento',
  'tickets.exportModal.modeByCategory': 'Una hoja por área (categoría)',
  'tickets.exportModal.deptScope': 'Departamentos a incluir',
  'tickets.exportModal.deptAll': 'Todos los departamentos (cada uno en su hoja)',
  'tickets.exportModal.deptOne': 'Solo este departamento',
  'tickets.exportModal.catScope': 'Áreas a incluir',
  'tickets.exportModal.catAll': 'Todas las áreas (cada una en su hoja)',
  'tickets.exportModal.catOne': 'Solo esta área',
  'tickets.exportModal.selectDept': 'Seleccionar departamento',
  'tickets.exportModal.selectCat': 'Seleccionar área',
  'tickets.exportModal.confirm': 'Descargar Excel',
  'tickets.exportModal.unassignedDept': 'Sin departamento',
  'tickets.exportModal.unassignedCat': 'Sin categoría',
  'tickets.exportModal.defaultSheet': 'Tickets',
  'tickets.department': 'Departamento',
  'tickets.allDepartments': 'Todos los departamentos',
  'tickets.area': 'Área (categoría)',
  'tickets.allAreas': 'Todas las áreas',
  'tickets.scope': 'Vigencia',
  'tickets.scopeAll': 'Todos (activos y cerrados)',
  'tickets.scopeOpen': 'Solo activos / abiertos',
  'tickets.scopeClosed': 'Solo cerrados o resueltos',
  'tickets.createTicket': 'Crear ticket',
  'tickets.filters': 'Filtros',
  'tickets.filtersAdvanced': 'Filtros avanzados',
  'tickets.filtersAdvancedShow': 'Mostrar avanzados',
  'tickets.filtersAdvancedHide': 'Ocultar avanzados',
  'tickets.filtersAdvancedActive': '{{count}} filtro(s) avanzado(s)',
  'tickets.filterMine': 'Solo mis tickets (asignados a mí o creados por mí)',
  'tickets.filterMineHint': 'Desmarque para listar todos los tickets.',
  'tickets.clearAll': 'Limpiar todo ({{count}})',
  'tickets.searchLabel': 'Buscar',
  'tickets.searchPlaceholder': 'Buscar por ID, título, cliente, planta...',
  'tickets.client': 'Cliente',
  'tickets.plant': 'Planta',
  'tickets.status': 'Estado',
  'tickets.priority': 'Prioridad',
  'tickets.itemsPerPage': 'Ítems por página',
  'tickets.allPlants': 'Todas las plantas',
  'tickets.selectedCount': '{{count}} ticket(s) seleccionado(s)',
  'tickets.assign': 'Asignar',
  'tickets.changeStatus': 'Cambiar estado',
  'tickets.col.ticketId': 'ID ticket',
  'tickets.col.title': 'Título',
  'tickets.col.category': 'Categoría',
  'tickets.col.owner': 'Responsable',
  'tickets.col.sla': 'SLA',
  'tickets.col.actions': 'Acciones',
  'tickets.view': 'Ver',
  'tickets.hoursOverdue': '{{hours}} h vencido',
  'tickets.hoursLeft': '{{hours}} h restantes',
  'tickets.bulk.assignTitle': 'Asignar tickets',
  'tickets.bulk.assignDesc': 'Seleccione un responsable para {{count}} ticket(s)',
  'tickets.bulk.assignFilteredHint':
    'La lista de usuarios se limita al departamento compartido por todos los tickets seleccionados (misma regla que en el detalle del ticket).',
  'tickets.bulk.selectOwner': 'Seleccionar responsable...',
  'tickets.bulk.cancel': 'Cancelar',
  'tickets.bulk.assigning': 'Asignando...',
  'tickets.bulk.assignBtn': 'Asignar',
  'tickets.bulk.statusTitle': 'Cambiar estado',
  'tickets.bulk.statusDesc':
    'Solo se muestran estados permitidos para todos los tickets seleccionados (mismas transiciones que en el detalle del ticket).',
  'tickets.bulk.statusNoCommon':
    'No hay un siguiente estado común para todos los tickets seleccionados (por ejemplo, los cerrados no se pueden cambiar aquí).',
  'tickets.bulk.selectStatus': 'Seleccionar estado...',
  'tickets.bulk.updating': 'Actualizando...',
  'tickets.bulk.statusBtn': 'Cambiar estado',
  'tickets.exportCols': 'ID,Título,Cliente,Planta,Estado,Prioridad,Responsable,Creado',
  'tickets.exportColsExcel':
    'ID,Número,Título,Cliente,Planta,Categoría,Departamento,Estado,Prioridad,Responsable,SLA,Creado',
  'tickets.toast.exportEmpty': 'No hay tickets para exportar con los filtros actuales',
  'tickets.toast.exportFail': 'Error al exportar tickets',
  'tickets.toast.assignOk': 'Se asignaron {{count}} ticket(s) correctamente',
  'tickets.toast.assignFail': 'Error al asignar tickets',
  'tickets.toast.statusNotAllowed': 'Ese estado no está permitido para todos los tickets seleccionados',
  'tickets.toast.statusOk': 'Estado actualizado para {{count}} ticket(s) correctamente',
  'tickets.toast.statusFail': 'Error al cambiar el estado',
  'tickets.toast.exportOk': '{{count}} ticket(s) exportado(s)',
  'tickets.toast.exportAllOk': 'Se exportaron {{count}} ticket(s) en {{sheets}} hoja(s) de Excel',
  'tickets.toast.filtersCleared': 'Se limpiaron todos los filtros',
  'tickets.toast.selectOne': 'Seleccione al menos un ticket',
  'tickets.toast.loadFail': 'Error al cargar tickets',
  'tickets.emptyTitle': 'No se encontraron tickets',
  'tickets.emptyDesc': 'Ningún ticket coincide con los filtros. Pruebe a ajustar la búsqueda.',
  'tickets.clearFilters': 'Limpiar filtros',

  'ticketDetail.loading': 'Cargando ticket...',
  'ticketDetail.notFoundTitle': 'Ticket no encontrado',
  'ticketDetail.notFoundDesc': 'El ticket que busca no existe.',
  'ticketDetail.backToTickets': 'Volver a tickets',
  'ticketDetail.printedOn': 'Impreso el {{date}}',
  'ticketDetail.printTicket': 'TICKET {{id}}',
  'ticketDetail.attachments': 'Adjuntos',
  'ticketDetail.activityTimeline': 'Historial de actividad',
  'ticketDetail.escalatedBanner': 'Ticket escalado',
  'ticketDetail.clientUpdates': 'Actualizaciones visibles al cliente',
  'ticketDetail.internalNotes': 'Notas internas',
  'ticketDetail.clientUpdatePlaceholder': 'Escriba una actualización visible para el cliente...',
  'ticketDetail.internalNotePlaceholder': 'Escriba una nota interna (no visible para el cliente)...',
  'ticketDetail.addClientUpdate': 'Agregar actualización al cliente',
  'ticketDetail.addInternalNote': 'Agregar nota interna',
  'ticketDetail.slaStatus': 'Estado SLA',
  'ticketDetail.overdue': 'Vencido',
  'ticketDetail.remaining': 'Restante',
  'ticketDetail.quickActions': 'Acciones rápidas',
  'ticketDetail.reassign': 'Reasignar ticket',
  'ticketDetail.reassignToNew': 'Poner estado en Nuevo (mantiene el historial)',
  'ticketDetail.reassignToNewHint': 'El nuevo responsable lo verá como ticket nuevo; el historial se conserva.',
  'ticketDetail.reassignEscalate': 'Escalar al mismo tiempo',
  'ticketDetail.reassignEscalateHint': 'El ticket permanecerá en Escalado y quedará registrado en el historial.',
  'ticketDetail.closedAdminOnly': 'Solo los administradores pueden cerrar un ticket.',
  'ticketDetail.escalateToDept': 'Departamento',
  'ticketDetail.escalateToUser': 'Usuario',
  'ticketDetail.selectDepartment': 'Seleccionar departamento',
  'ticketDetail.selectUser': 'Seleccionar usuario',
  'ticketDetail.cancel': 'Cancelar',
  'ticketDetail.confirmReassign': 'Confirmar reasignación',
  'ticketDetail.closeTicket': 'Cerrar ticket',
  'ticketDetail.resolutionPlaceholder': 'Describa cómo se resolvió el problema...',
  'ticketDetail.confirmClose': 'Confirmar cierre',
  'ticketDetail.confirmStatusTitle': 'Confirmar cambio de estado',
  'ticketDetail.confirmStatusBody': '¿Cambiar estado a <strong>{{status}}</strong>?',
  'ticketDetail.escalateTo': 'Escalar a',
  'ticketDetail.download': 'Descargar',
  'ticketDetail.delete': 'Eliminar',
  'ticketDetail.uploadAttach': 'Subir adjunto',
  'ticketDetail.dropFiles': 'Suelte archivos o haga clic para subir',
  'ticketDetail.noTimeline': 'Aún no hay eventos en el historial.',
  'ticketDetail.noAttachments': 'Aún no hay adjuntos.',
  'ticketDetail.createdBy': 'Creado por',
  'ticketDetail.createdAt': 'Creado el',
  'ticketDetail.estimatedResolution': 'Resolución estimada',
  'ticketDetail.resolvedAt': 'Resuelto el',
  'ticketDetail.slaHoursOverdue': '{{hours}} h vencido',
  'ticketDetail.slaHoursRemaining': '{{hours}} h restantes',
  'notFound.title': 'Página no encontrada',
  'notFound.description': 'Lo sentimos, la página que busca no existe o fue movida.',
  'notFound.goBack': 'Volver',
  'notFound.goDashboard': 'Ir al panel',
  'topbar.justNow': 'ahora mismo',
  'topbar.minAgo': 'hace {{count}} min',
  'topbar.hourAgo': 'hace {{count}} hora',
  'topbar.hoursAgo': 'hace {{count}} horas',
  'topbar.dayAgo': 'hace {{count}} día',
  'topbar.daysAgo': 'hace {{count}} días',
  'topbar.action.create': 'Creado',
  'topbar.action.update': 'Actualizado',
  'topbar.action.delete': 'Eliminado',
  'topbar.action.created': 'Creado',
  'topbar.action.updated': 'Actualizado',
  'topbar.action.deleted': 'Eliminado',
  'topbar.action.login': 'Inició sesión',
  'topbar.action.upload_attachment': 'Archivo subido',
  'topbar.action.delete_attachment': 'Archivo eliminado',
  'topbar.helpSupport': 'Ayuda / Soporte',
  'topbar.defaultUser': 'Usuario',
  'ticketDetail.invalidId': 'ID de ticket no válido',
  'ticketDetail.loadError': 'No se pudo cargar el ticket',
  'ticketDetail.noDescription': 'Sin descripción',
  'ticketDetail.noDescriptionShort': 'Sin descripción',
  'ticketDetail.printFooter': 'Sistema de gestión de tickets Cysol • {{id}}',
  'ticketDetail.system': 'Sistema',
  'ticketDetail.internalBadge': 'Interno',
  'ticketDetail.postClientUpdateBtn': 'Publicar actualización al cliente',
  'ticketDetail.assignTo': 'Asignar a',
  'ticketDetail.reassignAction': 'Reasignar',
  'ticketDetail.closeTicketAction': 'Cerrar ticket',
  'ticketDetail.uploadFile': 'Subir archivo',
  'ticketDetail.printTicketBtn': 'Imprimir ticket',
  'ticketDetail.shareTicket': 'Compartir ticket',
  'ticketDetail.duplicateTicket': 'Duplicar ticket',
  'ticketDetail.resolutionSummaryLabel': 'Resumen de resolución',
  'ticketDetail.confirmStatusChangeFromTo':
    '¿Seguro que desea cambiar el estado de {{from}} a {{to}}?',
  'ticketDetail.confirmBtn': 'Confirmar',
  'ticketDetail.escalateTicketTitle': 'Escalar ticket',
  'ticketDetail.escalateTicketIntro':
    'Indique a quién se escala el ticket. Quedará registrado en el historial.',
  'ticketDetail.escalateBtn': 'Escalar',
  'ticketDetail.escWarnEscWithHours':
    'Este ticket está escalado y lleva {{hours}} horas vencido. Requiere atención inmediata.',
  'ticketDetail.escWarnEscNoHours': 'Este ticket está escalado. Requiere atención inmediata.',
  'ticketDetail.escWarnInProgress':
    'Este ticket fue escalado y ahora está en curso. Sigue figurando como escalado en el historial.',
  'ticketDetail.commentDept': 'Departamento: {{name}}',
  'ticketDetail.commentUser': 'Usuario: {{name}}',
  'ticketDetail.userRef': 'Usuario #{{id}}',
  'ticketDetail.contactRef': 'Contacto #{{id}}',
  'ticketDetail.reassignSameOwner':
    'El ticket ya está asignado a esa persona. Elija otro responsable para reasignar.',
  'ticketDetail.reassignFail': 'No se pudo reasignar el ticket. Intente de nuevo.',
  'ticketDetail.reassignOk': 'Ticket reasignado correctamente.',
  'ticketDetail.reassignEscalationRequired': 'Indique a qué departamento o usuario escalar.',
  'ticketDetail.confirmReassignBtn': 'Reasignar',
  'common.unitBytes': 'B',
  'common.unitKb': 'KB',
  'common.unitMb': 'MB',
  'ticketDrawer.title': 'Detalle del ticket',
  'ticketDrawer.slaOverdueTitle': 'SLA vencido',
  'ticketDrawer.slaOverdueDesc': 'Este ticket lleva {{hours}} horas vencido y requiere atención inmediata.',
  'ticketDrawer.close': 'Cerrar',
  'ticketDrawer.viewFull': 'Ver ticket completo',
  'ticketDrawer.assignedTo': 'Asignado a',
};

export default es;
